var availableYears = ["1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"];
module.exports ={
	"States": [{
		"StateFIPS": "01",
		"StateName": "Alabama",
		"Counties": [{
			"GeoId": "01001",
			"Name": "Autauga County",
			"ShortName": "Autauga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01003",
			"Name": "Baldwin County",
			"ShortName": "Baldwin County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01005",
			"Name": "Barbour County",
			"ShortName": "Barbour",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01007",
			"Name": "Bibb County",
			"ShortName": "Bibb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01009",
			"Name": "Blount County",
			"ShortName": "Blount",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01011",
			"Name": "Bullock County",
			"ShortName": "Bullock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01013",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01015",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01017",
			"Name": "Chambers County",
			"ShortName": "Chambers",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01019",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01021",
			"Name": "Chilton County",
			"ShortName": "Chilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01023",
			"Name": "Choctaw County",
			"ShortName": "Choctaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01025",
			"Name": "Clarke County",
			"ShortName": "Clarke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01027",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01029",
			"Name": "Cleburne County",
			"ShortName": "Cleburne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01031",
			"Name": "Coffee County",
			"ShortName": "Coffee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01033",
			"Name": "Colbert County",
			"ShortName": "Colbert",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01035",
			"Name": "Conecuh County",
			"ShortName": "Conecuh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01037",
			"Name": "Coosa County",
			"ShortName": "Coosa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01039",
			"Name": "Covington County",
			"ShortName": "Covington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01041",
			"Name": "Crenshaw County",
			"ShortName": "Crenshaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01043",
			"Name": "Cullman County",
			"ShortName": "Cullman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01045",
			"Name": "Dale County",
			"ShortName": "Dale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01047",
			"Name": "Dallas County",
			"ShortName": "Dallas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01049",
			"Name": "DeKalb County",
			"ShortName": "DeKalb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01051",
			"Name": "Elmore County",
			"ShortName": "Elmore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01053",
			"Name": "Escambia County",
			"ShortName": "Escambia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01055",
			"Name": "Etowah County",
			"ShortName": "Etowah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01057",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01059",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01061",
			"Name": "Geneva County",
			"ShortName": "Geneva",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01063",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01065",
			"Name": "Hale County",
			"ShortName": "Hale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01067",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01069",
			"Name": "Houston County",
			"ShortName": "Houston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01071",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01073",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01075",
			"Name": "Lamar County",
			"ShortName": "Lamar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01077",
			"Name": "Lauderdale County",
			"ShortName": "Lauderdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01079",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01081",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01083",
			"Name": "Limestone County",
			"ShortName": "Limestone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01085",
			"Name": "Lowndes County",
			"ShortName": "Lowndes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01087",
			"Name": "Macon County",
			"ShortName": "Macon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01089",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01091",
			"Name": "Marengo County",
			"ShortName": "Marengo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01093",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01095",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01097",
			"Name": "Mobile County",
			"ShortName": "Mobile County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01099",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01101",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01103",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01105",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01107",
			"Name": "Pickens County",
			"ShortName": "Pickens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01109",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01111",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01113",
			"Name": "Russell County",
			"ShortName": "Russell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01117",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01115",
			"Name": "St. Clair County",
			"ShortName": "St. Clair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01119",
			"Name": "Sumter County",
			"ShortName": "Sumter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01121",
			"Name": "Talladega County",
			"ShortName": "Talladega",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01123",
			"Name": "Tallapoosa County",
			"ShortName": "Tallapoosa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01125",
			"Name": "Tuscaloosa County",
			"ShortName": "Tuscaloosa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01127",
			"Name": "Walker County",
			"ShortName": "Walker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01129",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01131",
			"Name": "Wilcox County",
			"ShortName": "Wilcox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "01133",
			"Name": "Winston County",
			"ShortName": "Winston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "04",
		"StateName": "Arizona",
		"Counties": [{
			"GeoId": "04001",
			"Name": "Apache County",
			"ShortName": "Apache",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04003",
			"Name": "Cochise County",
			"ShortName": "Cochise",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04005",
			"Name": "Coconino County",
			"ShortName": "Coconino",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04007",
			"Name": "Gila County",
			"ShortName": "Gila",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04009",
			"Name": "Graham County",
			"ShortName": "Graham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04011",
			"Name": "Greenlee County",
			"ShortName": "Greenlee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04012",
			"Name": "La Paz County",
			"ShortName": "La Paz",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04013",
			"Name": "Maricopa County",
			"ShortName": "Maricopa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04015",
			"Name": "Mohave County",
			"ShortName": "Mohave",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04017",
			"Name": "Navajo County",
			"ShortName": "Navajo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04019",
			"Name": "Pima County",
			"ShortName": "Pima",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04021",
			"Name": "Pinal County",
			"ShortName": "Pinal",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04023",
			"Name": "Santa Cruz County",
			"ShortName": "Santa Cruz",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04025",
			"Name": "Yavapai County",
			"ShortName": "Yavapai",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "04027",
			"Name": "Yuma County",
			"ShortName": "Yuma",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "05",
		"StateName": "Arkansas",
		"Counties": [{
			"GeoId": "05001",
			"Name": "Arkansas County",
			"ShortName": "Arkansas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05003",
			"Name": "Ashley County",
			"ShortName": "Ashley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05005",
			"Name": "Baxter County",
			"ShortName": "Baxter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05007",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05009",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05011",
			"Name": "Bradley County",
			"ShortName": "Bradley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05013",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05015",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05017",
			"Name": "Chicot County",
			"ShortName": "Chicot",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05019",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05021",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05023",
			"Name": "Cleburne County",
			"ShortName": "Cleburne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05025",
			"Name": "Cleveland County",
			"ShortName": "Cleveland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05027",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05029",
			"Name": "Conway County",
			"ShortName": "Conway",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05031",
			"Name": "Craighead County",
			"ShortName": "Craighead",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05033",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05035",
			"Name": "Crittenden County",
			"ShortName": "Crittenden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05037",
			"Name": "Cross County",
			"ShortName": "Cross",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05039",
			"Name": "Dallas County",
			"ShortName": "Dallas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05041",
			"Name": "Desha County",
			"ShortName": "Desha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05043",
			"Name": "Drew County",
			"ShortName": "Drew",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05045",
			"Name": "Faulkner County",
			"ShortName": "Faulkner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05047",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05049",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05051",
			"Name": "Garland County",
			"ShortName": "Garland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05053",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05055",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05057",
			"Name": "Hempstead County",
			"ShortName": "Hempstead",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05059",
			"Name": "Hot Spring County",
			"ShortName": "Hot Spring",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05061",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05063",
			"Name": "Independence County",
			"ShortName": "Independence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05065",
			"Name": "Izard County",
			"ShortName": "Izard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05067",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05069",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05071",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05073",
			"Name": "Lafayette County",
			"ShortName": "Lafayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05075",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05077",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05079",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05081",
			"Name": "Little River County",
			"ShortName": "Little River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05083",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05085",
			"Name": "Lonoke County",
			"ShortName": "Lonoke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05087",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05089",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05091",
			"Name": "Miller County",
			"ShortName": "Miller",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05093",
			"Name": "Mississippi County",
			"ShortName": "Mississippi",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05095",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05097",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05099",
			"Name": "Nevada County",
			"ShortName": "Nevada",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05101",
			"Name": "Newton County",
			"ShortName": "Newton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05103",
			"Name": "Ouachita County",
			"ShortName": "Ouachita",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05105",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05107",
			"Name": "Phillips County",
			"ShortName": "Phillips",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05109",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05111",
			"Name": "Poinsett County",
			"ShortName": "Poinsett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05113",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05115",
			"Name": "Pope County",
			"ShortName": "Pope",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05117",
			"Name": "Prairie County",
			"ShortName": "Prairie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05119",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05121",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05125",
			"Name": "Saline County",
			"ShortName": "Saline",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05127",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05129",
			"Name": "Searcy County",
			"ShortName": "Searcy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05131",
			"Name": "Sebastian County",
			"ShortName": "Sebastian",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05133",
			"Name": "Sevier County",
			"ShortName": "Sevier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05135",
			"Name": "Sharp County",
			"ShortName": "Sharp",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05123",
			"Name": "St. Francis County",
			"ShortName": "St. Francis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05137",
			"Name": "Stone County",
			"ShortName": "Stone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05139",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05141",
			"Name": "Van Buren County",
			"ShortName": "Van Buren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05143",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05145",
			"Name": "White County",
			"ShortName": "White",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05147",
			"Name": "Woodruff County",
			"ShortName": "Woodruff",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "05149",
			"Name": "Yell County",
			"ShortName": "Yell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "06",
		"StateName": "California",
		"Counties": [{
			"GeoId": "06001",
			"Name": "Alameda County",
			"ShortName": "Alameda County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06003",
			"Name": "Alpine County",
			"ShortName": "Alpine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06005",
			"Name": "Amador County",
			"ShortName": "Amador",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06007",
			"Name": "Butte County",
			"ShortName": "Butte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06009",
			"Name": "Calaveras County",
			"ShortName": "Calaveras",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06011",
			"Name": "Colusa County",
			"ShortName": "Colusa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06013",
			"Name": "Contra Costa County",
			"ShortName": "Contra Costa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06015",
			"Name": "Del Norte County",
			"ShortName": "Del Norte County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06017",
			"Name": "El Dorado County",
			"ShortName": "El Dorado",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06019",
			"Name": "Fresno County",
			"ShortName": "Fresno",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06021",
			"Name": "Glenn County",
			"ShortName": "Glenn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06023",
			"Name": "Humboldt County",
			"ShortName": "Humboldt County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06025",
			"Name": "Imperial County",
			"ShortName": "Imperial",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06027",
			"Name": "Inyo County",
			"ShortName": "Inyo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06029",
			"Name": "Kern County",
			"ShortName": "Kern",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06031",
			"Name": "Kings County",
			"ShortName": "Kings",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06033",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06035",
			"Name": "Lassen County",
			"ShortName": "Lassen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06037",
			"Name": "Los Angeles County",
			"ShortName": "Los Angeles County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06039",
			"Name": "Madera County",
			"ShortName": "Madera",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06041",
			"Name": "Marin County",
			"ShortName": "Marin County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06043",
			"Name": "Mariposa County",
			"ShortName": "Mariposa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06045",
			"Name": "Mendocino County",
			"ShortName": "Mendocino County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06047",
			"Name": "Merced County",
			"ShortName": "Merced",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06049",
			"Name": "Modoc County",
			"ShortName": "Modoc",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06051",
			"Name": "Mono County",
			"ShortName": "Mono",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06053",
			"Name": "Monterey County",
			"ShortName": "Monterey County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06055",
			"Name": "Napa County",
			"ShortName": "Napa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06057",
			"Name": "Nevada County",
			"ShortName": "Nevada",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06059",
			"Name": "Orange County",
			"ShortName": "Orange County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06061",
			"Name": "Placer County",
			"ShortName": "Placer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06063",
			"Name": "Plumas County",
			"ShortName": "Plumas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06065",
			"Name": "Riverside County",
			"ShortName": "Riverside",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06067",
			"Name": "Sacramento County",
			"ShortName": "Sacramento County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06069",
			"Name": "San Benito County",
			"ShortName": "San Benito",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06071",
			"Name": "San Bernardino County",
			"ShortName": "San Bernardino",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06073",
			"Name": "San Diego County",
			"ShortName": "San Diego County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06075",
			"Name": "San Francisco County",
			"ShortName": "San Francisco County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06077",
			"Name": "San Joaquin County",
			"ShortName": "San Joaquin County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06079",
			"Name": "San Luis Obispo County",
			"ShortName": "San Luis Obispo County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06081",
			"Name": "San Mateo County",
			"ShortName": "San Mateo County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06083",
			"Name": "Santa Barbara County",
			"ShortName": "Santa Barbara County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06085",
			"Name": "Santa Clara County",
			"ShortName": "Santa Clara County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06087",
			"Name": "Santa Cruz County",
			"ShortName": "Santa Cruz County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06089",
			"Name": "Shasta County",
			"ShortName": "Shasta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06091",
			"Name": "Sierra County",
			"ShortName": "Sierra",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06093",
			"Name": "Siskiyou County",
			"ShortName": "Siskiyou",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06095",
			"Name": "Solano County",
			"ShortName": "Solano County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06097",
			"Name": "Sonoma County",
			"ShortName": "Sonoma County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06099",
			"Name": "Stanislaus County",
			"ShortName": "Stanislaus",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06101",
			"Name": "Sutter County",
			"ShortName": "Sutter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06103",
			"Name": "Tehama County",
			"ShortName": "Tehama",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06105",
			"Name": "Trinity County",
			"ShortName": "Trinity",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06107",
			"Name": "Tulare County",
			"ShortName": "Tulare",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06109",
			"Name": "Tuolumne County",
			"ShortName": "Tuolumne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06111",
			"Name": "Ventura County",
			"ShortName": "Ventura County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06113",
			"Name": "Yolo County",
			"ShortName": "Yolo County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "06115",
			"Name": "Yuba County",
			"ShortName": "Yuba",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "08",
		"StateName": "Colorado",
		"Counties": [{
			"GeoId": "08001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08003",
			"Name": "Alamosa County",
			"ShortName": "Alamosa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08005",
			"Name": "Arapahoe County",
			"ShortName": "Arapahoe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08007",
			"Name": "Archuleta County",
			"ShortName": "Archuleta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08009",
			"Name": "Baca County",
			"ShortName": "Baca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08011",
			"Name": "Bent County",
			"ShortName": "Bent",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08013",
			"Name": "Boulder County",
			"ShortName": "Boulder",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08014",
			"Name": "Broomfield County",
			"ShortName": "Broomfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08015",
			"Name": "Chaffee County",
			"ShortName": "Chaffee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08017",
			"Name": "Cheyenne County",
			"ShortName": "Cheyenne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08019",
			"Name": "Clear Creek County",
			"ShortName": "Clear Creek",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08021",
			"Name": "Conejos County",
			"ShortName": "Conejos",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08023",
			"Name": "Costilla County",
			"ShortName": "Costilla",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08025",
			"Name": "Crowley County",
			"ShortName": "Crowley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08027",
			"Name": "Custer County",
			"ShortName": "Custer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08029",
			"Name": "Delta County",
			"ShortName": "Delta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08031",
			"Name": "Denver County",
			"ShortName": "Denver",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08033",
			"Name": "Dolores County",
			"ShortName": "Dolores",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08035",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08037",
			"Name": "Eagle County",
			"ShortName": "Eagle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08041",
			"Name": "El Paso County",
			"ShortName": "El Paso",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08039",
			"Name": "Elbert County",
			"ShortName": "Elbert",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08043",
			"Name": "Fremont County",
			"ShortName": "Fremont",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08045",
			"Name": "Garfield County",
			"ShortName": "Garfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08047",
			"Name": "Gilpin County",
			"ShortName": "Gilpin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08049",
			"Name": "Grand County",
			"ShortName": "Grand",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08051",
			"Name": "Gunnison County",
			"ShortName": "Gunnison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08053",
			"Name": "Hinsdale County",
			"ShortName": "Hinsdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08055",
			"Name": "Huerfano County",
			"ShortName": "Huerfano",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08057",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08059",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08061",
			"Name": "Kiowa County",
			"ShortName": "Kiowa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08063",
			"Name": "Kit Carson County",
			"ShortName": "Kit Carson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08067",
			"Name": "La Plata County",
			"ShortName": "La Plata",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08065",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08069",
			"Name": "Larimer County",
			"ShortName": "Larimer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08071",
			"Name": "Las Animas County",
			"ShortName": "Las Animas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08073",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08075",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08077",
			"Name": "Mesa County",
			"ShortName": "Mesa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08079",
			"Name": "Mineral County",
			"ShortName": "Mineral",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08081",
			"Name": "Moffat County",
			"ShortName": "Moffat",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08083",
			"Name": "Montezuma County",
			"ShortName": "Montezuma",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08085",
			"Name": "Montrose County",
			"ShortName": "Montrose",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08087",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08089",
			"Name": "Otero County",
			"ShortName": "Otero",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08091",
			"Name": "Ouray County",
			"ShortName": "Ouray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08093",
			"Name": "Park County",
			"ShortName": "Park",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08095",
			"Name": "Phillips County",
			"ShortName": "Phillips",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08097",
			"Name": "Pitkin County",
			"ShortName": "Pitkin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08099",
			"Name": "Prowers County",
			"ShortName": "Prowers",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08101",
			"Name": "Pueblo County",
			"ShortName": "Pueblo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08103",
			"Name": "Rio Blanco County",
			"ShortName": "Rio Blanco",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08105",
			"Name": "Rio Grande County",
			"ShortName": "Rio Grande",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08107",
			"Name": "Routt County",
			"ShortName": "Routt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08109",
			"Name": "Saguache County",
			"ShortName": "Saguache",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08111",
			"Name": "San Juan County",
			"ShortName": "San Juan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08113",
			"Name": "San Miguel County",
			"ShortName": "San Miguel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08115",
			"Name": "Sedgwick County",
			"ShortName": "Sedgwick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08117",
			"Name": "Summit County",
			"ShortName": "Summit",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08119",
			"Name": "Teller County",
			"ShortName": "Teller",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08121",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08123",
			"Name": "Weld County",
			"ShortName": "Weld",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "08125",
			"Name": "Yuma County",
			"ShortName": "Yuma",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "09",
		"StateName": "Connecticut",
		"Counties": [{
			"GeoId": "09001",
			"Name": "Fairfield County",
			"ShortName": "Fairfield County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09003",
			"Name": "Hartford County",
			"ShortName": "Hartford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09005",
			"Name": "Litchfield County",
			"ShortName": "Litchfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09007",
			"Name": "Middlesex County",
			"ShortName": "Middlesex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09009",
			"Name": "New Haven County",
			"ShortName": "New Haven County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09011",
			"Name": "New London County",
			"ShortName": "New London County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09013",
			"Name": "Tolland County",
			"ShortName": "Tolland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "09015",
			"Name": "Windham County",
			"ShortName": "Windham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "10",
		"StateName": "Delaware",
		"Counties": [{
			"GeoId": "10001",
			"Name": "Kent County",
			"ShortName": "Kent County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "10003",
			"Name": "New Castle County",
			"ShortName": "New Castle County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "10005",
			"Name": "Sussex County",
			"ShortName": "Sussex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "11",
		"StateName": "District of Columbia",
		"Counties": [{
			"GeoId": "11001",
			"Name": "District of Columbia County",
			"ShortName": "District of Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "12",
		"StateName": "Florida",
		"Counties": [{
			"GeoId": "12001",
			"Name": "Alachua County",
			"ShortName": "Alachua",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12003",
			"Name": "Baker County",
			"ShortName": "Baker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12005",
			"Name": "Bay County",
			"ShortName": "Bay County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12007",
			"Name": "Bradford County",
			"ShortName": "Bradford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12009",
			"Name": "Brevard County",
			"ShortName": "Brevard County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12011",
			"Name": "Broward County",
			"ShortName": "Broward County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12013",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12015",
			"Name": "Charlotte County",
			"ShortName": "Charlotte County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12017",
			"Name": "Citrus County",
			"ShortName": "Citrus County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12019",
			"Name": "Clay County",
			"ShortName": "Clay County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12021",
			"Name": "Collier County",
			"ShortName": "Collier County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12023",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12027",
			"Name": "DeSoto County",
			"ShortName": "DeSoto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12029",
			"Name": "Dixie County",
			"ShortName": "Dixie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12031",
			"Name": "Duval County",
			"ShortName": "Duval County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12033",
			"Name": "Escambia County",
			"ShortName": "Escambia County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12035",
			"Name": "Flagler County",
			"ShortName": "Flagler County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12037",
			"Name": "Franklin County",
			"ShortName": "Franklin County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12039",
			"Name": "Gadsden County",
			"ShortName": "Gadsden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12041",
			"Name": "Gilchrist County",
			"ShortName": "Gilchrist",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12043",
			"Name": "Glades County",
			"ShortName": "Glades",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12045",
			"Name": "Gulf County",
			"ShortName": "Gulf County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12047",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12049",
			"Name": "Hardee County",
			"ShortName": "Hardee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12051",
			"Name": "Hendry County",
			"ShortName": "Hendry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12053",
			"Name": "Hernando County",
			"ShortName": "Hernando County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12055",
			"Name": "Highlands County",
			"ShortName": "Highlands",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12057",
			"Name": "Hillsborough County",
			"ShortName": "Hillsborough County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12059",
			"Name": "Holmes County",
			"ShortName": "Holmes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12061",
			"Name": "Indian River County",
			"ShortName": "Indian River County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12063",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12065",
			"Name": "Jefferson County",
			"ShortName": "Jefferson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12067",
			"Name": "Lafayette County",
			"ShortName": "Lafayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12069",
			"Name": "Lake County",
			"ShortName": "Lake County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12071",
			"Name": "Lee County",
			"ShortName": "Lee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12073",
			"Name": "Leon County",
			"ShortName": "Leon County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12075",
			"Name": "Levy County",
			"ShortName": "Levy County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12077",
			"Name": "Liberty County",
			"ShortName": "Liberty County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12079",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12081",
			"Name": "Manatee County",
			"ShortName": "Manatee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12083",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12085",
			"Name": "Martin County",
			"ShortName": "Martin County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12086",
			"Name": "Miami-Dade County",
			"ShortName": "Miami-Dade County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12087",
			"Name": "Monroe County",
			"ShortName": "Monroe County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12089",
			"Name": "Nassau County",
			"ShortName": "Nassau County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12091",
			"Name": "Okaloosa County",
			"ShortName": "Okaloosa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12093",
			"Name": "Okeechobee County",
			"ShortName": "Okeechobee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12095",
			"Name": "Orange County",
			"ShortName": "Orange County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12097",
			"Name": "Osceola County",
			"ShortName": "Osceola",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12099",
			"Name": "Palm Beach County",
			"ShortName": "Palm Beach County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12101",
			"Name": "Pasco County",
			"ShortName": "Pasco County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12103",
			"Name": "Pinellas County",
			"ShortName": "Pinellas County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12105",
			"Name": "Polk County",
			"ShortName": "Polk County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12107",
			"Name": "Putnam County",
			"ShortName": "Putnam County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12113",
			"Name": "Santa Rosa County",
			"ShortName": "Santa Rosa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12115",
			"Name": "Sarasota County",
			"ShortName": "Sarasota County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12117",
			"Name": "Seminole County",
			"ShortName": "Seminole County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12109",
			"Name": "St. Johns County",
			"ShortName": "St. Johns County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12111",
			"Name": "St. Lucie County",
			"ShortName": "St. Lucie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12119",
			"Name": "Sumter County",
			"ShortName": "Sumter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12121",
			"Name": "Suwannee County",
			"ShortName": "Suwannee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12123",
			"Name": "Taylor County",
			"ShortName": "Taylor County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12125",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12127",
			"Name": "Volusia County",
			"ShortName": "Volusia County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12129",
			"Name": "Wakulla County",
			"ShortName": "Wakulla County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12131",
			"Name": "Walton County",
			"ShortName": "Walton County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "12133",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "13",
		"StateName": "Georgia",
		"Counties": [{
			"GeoId": "13001",
			"Name": "Appling County",
			"ShortName": "Appling",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13003",
			"Name": "Atkinson County",
			"ShortName": "Atkinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13005",
			"Name": "Bacon County",
			"ShortName": "Bacon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13007",
			"Name": "Baker County",
			"ShortName": "Baker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13009",
			"Name": "Baldwin County",
			"ShortName": "Baldwin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13011",
			"Name": "Banks County",
			"ShortName": "Banks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13013",
			"Name": "Barrow County",
			"ShortName": "Barrow",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13015",
			"Name": "Bartow County",
			"ShortName": "Bartow",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13017",
			"Name": "Ben Hill County",
			"ShortName": "Ben Hill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13019",
			"Name": "Berrien County",
			"ShortName": "Berrien",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13021",
			"Name": "Bibb County",
			"ShortName": "Bibb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13023",
			"Name": "Bleckley County",
			"ShortName": "Bleckley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13025",
			"Name": "Brantley County",
			"ShortName": "Brantley County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13027",
			"Name": "Brooks County",
			"ShortName": "Brooks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13029",
			"Name": "Bryan County",
			"ShortName": "Bryan County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13031",
			"Name": "Bulloch County",
			"ShortName": "Bulloch",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13033",
			"Name": "Burke County",
			"ShortName": "Burke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13035",
			"Name": "Butts County",
			"ShortName": "Butts",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13037",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13039",
			"Name": "Camden County",
			"ShortName": "Camden County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13043",
			"Name": "Candler County",
			"ShortName": "Candler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13045",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13047",
			"Name": "Catoosa County",
			"ShortName": "Catoosa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13049",
			"Name": "Charlton County",
			"ShortName": "Charlton County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13051",
			"Name": "Chatham County",
			"ShortName": "Chatham County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13053",
			"Name": "Chattahoochee County",
			"ShortName": "Chattahoochee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13055",
			"Name": "Chattooga County",
			"ShortName": "Chattooga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13057",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13059",
			"Name": "Clarke County",
			"ShortName": "Clarke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13061",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13063",
			"Name": "Clayton County",
			"ShortName": "Clayton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13065",
			"Name": "Clinch County",
			"ShortName": "Clinch",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13067",
			"Name": "Cobb County",
			"ShortName": "Cobb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13069",
			"Name": "Coffee County",
			"ShortName": "Coffee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13071",
			"Name": "Colquitt County",
			"ShortName": "Colquitt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13073",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13075",
			"Name": "Cook County",
			"ShortName": "Cook",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13077",
			"Name": "Coweta County",
			"ShortName": "Coweta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13079",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13081",
			"Name": "Crisp County",
			"ShortName": "Crisp",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13083",
			"Name": "Dade County",
			"ShortName": "Dade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13085",
			"Name": "Dawson County",
			"ShortName": "Dawson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13087",
			"Name": "Decatur County",
			"ShortName": "Decatur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13089",
			"Name": "DeKalb County",
			"ShortName": "DeKalb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13091",
			"Name": "Dodge County",
			"ShortName": "Dodge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13093",
			"Name": "Dooly County",
			"ShortName": "Dooly",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13095",
			"Name": "Dougherty County",
			"ShortName": "Dougherty",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13097",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13099",
			"Name": "Early County",
			"ShortName": "Early",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13101",
			"Name": "Echols County",
			"ShortName": "Echols",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13103",
			"Name": "Effingham County",
			"ShortName": "Effingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13105",
			"Name": "Elbert County",
			"ShortName": "Elbert",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13107",
			"Name": "Emanuel County",
			"ShortName": "Emanuel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13109",
			"Name": "Evans County",
			"ShortName": "Evans",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13111",
			"Name": "Fannin County",
			"ShortName": "Fannin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13113",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13115",
			"Name": "Floyd County",
			"ShortName": "Floyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13117",
			"Name": "Forsyth County",
			"ShortName": "Forsyth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13119",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13121",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13123",
			"Name": "Gilmer County",
			"ShortName": "Gilmer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13125",
			"Name": "Glascock County",
			"ShortName": "Glascock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13127",
			"Name": "Glynn County",
			"ShortName": "Glynn County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13129",
			"Name": "Gordon County",
			"ShortName": "Gordon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13131",
			"Name": "Grady County",
			"ShortName": "Grady",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13133",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13135",
			"Name": "Gwinnett County",
			"ShortName": "Gwinnett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13137",
			"Name": "Habersham County",
			"ShortName": "Habersham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13139",
			"Name": "Hall County",
			"ShortName": "Hall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13141",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13143",
			"Name": "Haralson County",
			"ShortName": "Haralson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13145",
			"Name": "Harris County",
			"ShortName": "Harris",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13147",
			"Name": "Hart County",
			"ShortName": "Hart",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13149",
			"Name": "Heard County",
			"ShortName": "Heard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13151",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13153",
			"Name": "Houston County",
			"ShortName": "Houston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13155",
			"Name": "Irwin County",
			"ShortName": "Irwin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13157",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13159",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13161",
			"Name": "Jeff Davis County",
			"ShortName": "Jeff Davis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13163",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13165",
			"Name": "Jenkins County",
			"ShortName": "Jenkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13167",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13169",
			"Name": "Jones County",
			"ShortName": "Jones",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13171",
			"Name": "Lamar County",
			"ShortName": "Lamar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13173",
			"Name": "Lanier County",
			"ShortName": "Lanier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13175",
			"Name": "Laurens County",
			"ShortName": "Laurens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13177",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13179",
			"Name": "Liberty County",
			"ShortName": "Liberty County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13181",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13183",
			"Name": "Long County",
			"ShortName": "Long",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13185",
			"Name": "Lowndes County",
			"ShortName": "Lowndes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13187",
			"Name": "Lumpkin County",
			"ShortName": "Lumpkin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13193",
			"Name": "Macon County",
			"ShortName": "Macon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13195",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13197",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13189",
			"Name": "McDuffie County",
			"ShortName": "McDuffie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13191",
			"Name": "McIntosh County",
			"ShortName": "McIntosh County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13199",
			"Name": "Meriwether County",
			"ShortName": "Meriwether",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13201",
			"Name": "Miller County",
			"ShortName": "Miller",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13205",
			"Name": "Mitchell County",
			"ShortName": "Mitchell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13207",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13209",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13211",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13213",
			"Name": "Murray County",
			"ShortName": "Murray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13215",
			"Name": "Muscogee County",
			"ShortName": "Muscogee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13217",
			"Name": "Newton County",
			"ShortName": "Newton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13219",
			"Name": "Oconee County",
			"ShortName": "Oconee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13221",
			"Name": "Oglethorpe County",
			"ShortName": "Oglethorpe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13223",
			"Name": "Paulding County",
			"ShortName": "Paulding",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13225",
			"Name": "Peach County",
			"ShortName": "Peach",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13227",
			"Name": "Pickens County",
			"ShortName": "Pickens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13229",
			"Name": "Pierce County",
			"ShortName": "Pierce",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13231",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13233",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13235",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13237",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13239",
			"Name": "Quitman County",
			"ShortName": "Quitman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13241",
			"Name": "Rabun County",
			"ShortName": "Rabun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13243",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13245",
			"Name": "Richmond County",
			"ShortName": "Richmond",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13247",
			"Name": "Rockdale County",
			"ShortName": "Rockdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13249",
			"Name": "Schley County",
			"ShortName": "Schley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13251",
			"Name": "Screven County",
			"ShortName": "Screven",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13253",
			"Name": "Seminole County",
			"ShortName": "Seminole",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13255",
			"Name": "Spalding County",
			"ShortName": "Spalding",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13257",
			"Name": "Stephens County",
			"ShortName": "Stephens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13259",
			"Name": "Stewart County",
			"ShortName": "Stewart",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13261",
			"Name": "Sumter County",
			"ShortName": "Sumter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13263",
			"Name": "Talbot County",
			"ShortName": "Talbot",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13265",
			"Name": "Taliaferro County",
			"ShortName": "Taliaferro",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13267",
			"Name": "Tattnall County",
			"ShortName": "Tattnall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13269",
			"Name": "Taylor County",
			"ShortName": "Taylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13271",
			"Name": "Telfair County",
			"ShortName": "Telfair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13273",
			"Name": "Terrell County",
			"ShortName": "Terrell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13275",
			"Name": "Thomas County",
			"ShortName": "Thomas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13277",
			"Name": "Tift County",
			"ShortName": "Tift",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13279",
			"Name": "Toombs County",
			"ShortName": "Toombs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13281",
			"Name": "Towns County",
			"ShortName": "Towns",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13283",
			"Name": "Treutlen County",
			"ShortName": "Treutlen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13285",
			"Name": "Troup County",
			"ShortName": "Troup",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13287",
			"Name": "Turner County",
			"ShortName": "Turner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13289",
			"Name": "Twiggs County",
			"ShortName": "Twiggs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13291",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13293",
			"Name": "Upson County",
			"ShortName": "Upson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13295",
			"Name": "Walker County",
			"ShortName": "Walker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13297",
			"Name": "Walton County",
			"ShortName": "Walton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13299",
			"Name": "Ware County",
			"ShortName": "Ware",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13301",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13303",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13305",
			"Name": "Wayne County",
			"ShortName": "Wayne County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13307",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13309",
			"Name": "Wheeler County",
			"ShortName": "Wheeler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13311",
			"Name": "White County",
			"ShortName": "White",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13313",
			"Name": "Whitfield County",
			"ShortName": "Whitfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13315",
			"Name": "Wilcox County",
			"ShortName": "Wilcox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13317",
			"Name": "Wilkes County",
			"ShortName": "Wilkes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13319",
			"Name": "Wilkinson County",
			"ShortName": "Wilkinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "13321",
			"Name": "Worth County",
			"ShortName": "Worth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "16",
		"StateName": "Idaho",
		"Counties": [{
			"GeoId": "16001",
			"Name": "Ada County",
			"ShortName": "Ada",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16003",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16005",
			"Name": "Bannock County",
			"ShortName": "Bannock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16007",
			"Name": "Bear Lake County",
			"ShortName": "Bear Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16009",
			"Name": "Benewah County",
			"ShortName": "Benewah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16011",
			"Name": "Bingham County",
			"ShortName": "Bingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16013",
			"Name": "Blaine County",
			"ShortName": "Blaine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16015",
			"Name": "Boise County",
			"ShortName": "Boise",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16017",
			"Name": "Bonner County",
			"ShortName": "Bonner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16019",
			"Name": "Bonneville County",
			"ShortName": "Bonneville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16021",
			"Name": "Boundary County",
			"ShortName": "Boundary",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16023",
			"Name": "Butte County",
			"ShortName": "Butte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16025",
			"Name": "Camas County",
			"ShortName": "Camas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16027",
			"Name": "Canyon County",
			"ShortName": "Canyon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16029",
			"Name": "Caribou County",
			"ShortName": "Caribou",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16031",
			"Name": "Cassia County",
			"ShortName": "Cassia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16033",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16035",
			"Name": "Clearwater County",
			"ShortName": "Clearwater",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16037",
			"Name": "Custer County",
			"ShortName": "Custer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16039",
			"Name": "Elmore County",
			"ShortName": "Elmore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16041",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16043",
			"Name": "Fremont County",
			"ShortName": "Fremont",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16045",
			"Name": "Gem County",
			"ShortName": "Gem",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16047",
			"Name": "Gooding County",
			"ShortName": "Gooding",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16049",
			"Name": "Idaho County",
			"ShortName": "Idaho",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16051",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16053",
			"Name": "Jerome County",
			"ShortName": "Jerome",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16055",
			"Name": "Kootenai County",
			"ShortName": "Kootenai",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16057",
			"Name": "Latah County",
			"ShortName": "Latah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16059",
			"Name": "Lemhi County",
			"ShortName": "Lemhi",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16061",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16063",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16065",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16067",
			"Name": "Minidoka County",
			"ShortName": "Minidoka",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16069",
			"Name": "Nez Perce County",
			"ShortName": "Nez Perce",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16071",
			"Name": "Oneida County",
			"ShortName": "Oneida",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16073",
			"Name": "Owyhee County",
			"ShortName": "Owyhee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16075",
			"Name": "Payette County",
			"ShortName": "Payette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16077",
			"Name": "Power County",
			"ShortName": "Power",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16079",
			"Name": "Shoshone County",
			"ShortName": "Shoshone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16081",
			"Name": "Teton County",
			"ShortName": "Teton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16083",
			"Name": "Twin Falls County",
			"ShortName": "Twin Falls",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16085",
			"Name": "Valley County",
			"ShortName": "Valley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "16087",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "17",
		"StateName": "Illinois",
		"Counties": [{
			"GeoId": "17001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17003",
			"Name": "Alexander County",
			"ShortName": "Alexander",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17005",
			"Name": "Bond County",
			"ShortName": "Bond",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17007",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17009",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17011",
			"Name": "Bureau County",
			"ShortName": "Bureau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17013",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17015",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17017",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17019",
			"Name": "Champaign County",
			"ShortName": "Champaign",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17021",
			"Name": "Christian County",
			"ShortName": "Christian",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17023",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17025",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17027",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17029",
			"Name": "Coles County",
			"ShortName": "Coles",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17031",
			"Name": "Cook County",
			"ShortName": "Cook County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17033",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17035",
			"Name": "Cumberland County",
			"ShortName": "Cumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17039",
			"Name": "De Witt County",
			"ShortName": "De Witt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17037",
			"Name": "DeKalb County",
			"ShortName": "DeKalb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17041",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17043",
			"Name": "DuPage County",
			"ShortName": "DuPage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17045",
			"Name": "Edgar County",
			"ShortName": "Edgar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17047",
			"Name": "Edwards County",
			"ShortName": "Edwards",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17049",
			"Name": "Effingham County",
			"ShortName": "Effingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17051",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17053",
			"Name": "Ford County",
			"ShortName": "Ford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17055",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17057",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17059",
			"Name": "Gallatin County",
			"ShortName": "Gallatin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17061",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17063",
			"Name": "Grundy County",
			"ShortName": "Grundy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17065",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17067",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17069",
			"Name": "Hardin County",
			"ShortName": "Hardin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17071",
			"Name": "Henderson County",
			"ShortName": "Henderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17073",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17075",
			"Name": "Iroquois County",
			"ShortName": "Iroquois",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17077",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17079",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17081",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17083",
			"Name": "Jersey County",
			"ShortName": "Jersey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17085",
			"Name": "Jo Daviess County",
			"ShortName": "Jo Daviess",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17087",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17089",
			"Name": "Kane County",
			"ShortName": "Kane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17091",
			"Name": "Kankakee County",
			"ShortName": "Kankakee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17093",
			"Name": "Kendall County",
			"ShortName": "Kendall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17095",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17097",
			"Name": "Lake County",
			"ShortName": "Lake County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17099",
			"Name": "LaSalle County",
			"ShortName": "LaSalle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17101",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17103",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17105",
			"Name": "Livingston County",
			"ShortName": "Livingston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17107",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17115",
			"Name": "Macon County",
			"ShortName": "Macon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17117",
			"Name": "Macoupin County",
			"ShortName": "Macoupin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17119",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17121",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17123",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17125",
			"Name": "Mason County",
			"ShortName": "Mason",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17127",
			"Name": "Massac County",
			"ShortName": "Massac",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17109",
			"Name": "McDonough County",
			"ShortName": "McDonough",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17111",
			"Name": "McHenry County",
			"ShortName": "McHenry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17113",
			"Name": "McLean County",
			"ShortName": "McLean",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17129",
			"Name": "Menard County",
			"ShortName": "Menard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17131",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17133",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17135",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17137",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17139",
			"Name": "Moultrie County",
			"ShortName": "Moultrie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17141",
			"Name": "Ogle County",
			"ShortName": "Ogle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17143",
			"Name": "Peoria County",
			"ShortName": "Peoria",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17145",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17147",
			"Name": "Piatt County",
			"ShortName": "Piatt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17149",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17151",
			"Name": "Pope County",
			"ShortName": "Pope",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17153",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17155",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17157",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17159",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17161",
			"Name": "Rock Island County",
			"ShortName": "Rock Island",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17165",
			"Name": "Saline County",
			"ShortName": "Saline",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17167",
			"Name": "Sangamon County",
			"ShortName": "Sangamon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17169",
			"Name": "Schuyler County",
			"ShortName": "Schuyler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17171",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17173",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17163",
			"Name": "St. Clair County",
			"ShortName": "St. Clair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17175",
			"Name": "Stark County",
			"ShortName": "Stark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17177",
			"Name": "Stephenson County",
			"ShortName": "Stephenson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17179",
			"Name": "Tazewell County",
			"ShortName": "Tazewell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17181",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17183",
			"Name": "Vermilion County",
			"ShortName": "Vermilion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17185",
			"Name": "Wabash County",
			"ShortName": "Wabash",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17187",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17189",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17191",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17193",
			"Name": "White County",
			"ShortName": "White",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17195",
			"Name": "Whiteside County",
			"ShortName": "Whiteside",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17197",
			"Name": "Will County",
			"ShortName": "Will",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17199",
			"Name": "Williamson County",
			"ShortName": "Williamson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17201",
			"Name": "Winnebago County",
			"ShortName": "Winnebago",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "17203",
			"Name": "Woodford County",
			"ShortName": "Woodford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "18",
		"StateName": "Indiana",
		"Counties": [{
			"GeoId": "18001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18003",
			"Name": "Allen County",
			"ShortName": "Allen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18005",
			"Name": "Bartholomew County",
			"ShortName": "Bartholomew",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18007",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18009",
			"Name": "Blackford County",
			"ShortName": "Blackford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18011",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18013",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18015",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18017",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18019",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18021",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18023",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18025",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18027",
			"Name": "Daviess County",
			"ShortName": "Daviess",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18029",
			"Name": "Dearborn County",
			"ShortName": "Dearborn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18031",
			"Name": "Decatur County",
			"ShortName": "Decatur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18033",
			"Name": "DeKalb County",
			"ShortName": "DeKalb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18035",
			"Name": "Delaware County",
			"ShortName": "Delaware",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18037",
			"Name": "Dubois County",
			"ShortName": "Dubois",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18039",
			"Name": "Elkhart County",
			"ShortName": "Elkhart",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18041",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18043",
			"Name": "Floyd County",
			"ShortName": "Floyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18045",
			"Name": "Fountain County",
			"ShortName": "Fountain",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18047",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18049",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18051",
			"Name": "Gibson County",
			"ShortName": "Gibson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18053",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18055",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18057",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18059",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18061",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18063",
			"Name": "Hendricks County",
			"ShortName": "Hendricks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18065",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18067",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18069",
			"Name": "Huntington County",
			"ShortName": "Huntington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18071",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18073",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18075",
			"Name": "Jay County",
			"ShortName": "Jay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18077",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18079",
			"Name": "Jennings County",
			"ShortName": "Jennings",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18081",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18083",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18085",
			"Name": "Kosciusko County",
			"ShortName": "Kosciusko",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18087",
			"Name": "LaGrange County",
			"ShortName": "LaGrange",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18089",
			"Name": "Lake County",
			"ShortName": "Lake County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18091",
			"Name": "LaPorte County",
			"ShortName": "LaPorte County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18093",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18095",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18097",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18099",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18101",
			"Name": "Martin County",
			"ShortName": "Martin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18103",
			"Name": "Miami County",
			"ShortName": "Miami",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18105",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18107",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18109",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18111",
			"Name": "Newton County",
			"ShortName": "Newton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18113",
			"Name": "Noble County",
			"ShortName": "Noble",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18115",
			"Name": "Ohio County",
			"ShortName": "Ohio",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18117",
			"Name": "Orange County",
			"ShortName": "Orange",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18119",
			"Name": "Owen County",
			"ShortName": "Owen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18121",
			"Name": "Parke County",
			"ShortName": "Parke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18123",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18125",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18127",
			"Name": "Porter County",
			"ShortName": "Porter County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18129",
			"Name": "Posey County",
			"ShortName": "Posey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18131",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18133",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18135",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18137",
			"Name": "Ripley County",
			"ShortName": "Ripley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18139",
			"Name": "Rush County",
			"ShortName": "Rush",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18143",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18145",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18147",
			"Name": "Spencer County",
			"ShortName": "Spencer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18141",
			"Name": "St. Joseph County",
			"ShortName": "St. Joseph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18149",
			"Name": "Starke County",
			"ShortName": "Starke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18151",
			"Name": "Steuben County",
			"ShortName": "Steuben",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18153",
			"Name": "Sullivan County",
			"ShortName": "Sullivan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18155",
			"Name": "Switzerland County",
			"ShortName": "Switzerland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18157",
			"Name": "Tippecanoe County",
			"ShortName": "Tippecanoe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18159",
			"Name": "Tipton County",
			"ShortName": "Tipton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18161",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18163",
			"Name": "Vanderburgh County",
			"ShortName": "Vanderburgh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18165",
			"Name": "Vermillion County",
			"ShortName": "Vermillion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18167",
			"Name": "Vigo County",
			"ShortName": "Vigo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18169",
			"Name": "Wabash County",
			"ShortName": "Wabash",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18171",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18173",
			"Name": "Warrick County",
			"ShortName": "Warrick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18175",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18177",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18179",
			"Name": "Wells County",
			"ShortName": "Wells",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18181",
			"Name": "White County",
			"ShortName": "White",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "18183",
			"Name": "Whitley County",
			"ShortName": "Whitley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "19",
		"StateName": "Iowa",
		"Counties": [{
			"GeoId": "19001",
			"Name": "Adair County",
			"ShortName": "Adair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19003",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19005",
			"Name": "Allamakee County",
			"ShortName": "Allamakee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19007",
			"Name": "Appanoose County",
			"ShortName": "Appanoose",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19009",
			"Name": "Audubon County",
			"ShortName": "Audubon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19011",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19013",
			"Name": "Black Hawk County",
			"ShortName": "Black Hawk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19015",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19017",
			"Name": "Bremer County",
			"ShortName": "Bremer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19019",
			"Name": "Buchanan County",
			"ShortName": "Buchanan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19021",
			"Name": "Buena Vista County",
			"ShortName": "Buena Vista",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19023",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19025",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19027",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19029",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19031",
			"Name": "Cedar County",
			"ShortName": "Cedar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19033",
			"Name": "Cerro Gordo County",
			"ShortName": "Cerro Gordo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19035",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19037",
			"Name": "Chickasaw County",
			"ShortName": "Chickasaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19039",
			"Name": "Clarke County",
			"ShortName": "Clarke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19041",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19043",
			"Name": "Clayton County",
			"ShortName": "Clayton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19045",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19047",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19049",
			"Name": "Dallas County",
			"ShortName": "Dallas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19051",
			"Name": "Davis County",
			"ShortName": "Davis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19053",
			"Name": "Decatur County",
			"ShortName": "Decatur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19055",
			"Name": "Delaware County",
			"ShortName": "Delaware",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19057",
			"Name": "Des Moines County",
			"ShortName": "Des Moines",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19059",
			"Name": "Dickinson County",
			"ShortName": "Dickinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19061",
			"Name": "Dubuque County",
			"ShortName": "Dubuque",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19063",
			"Name": "Emmet County",
			"ShortName": "Emmet",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19065",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19067",
			"Name": "Floyd County",
			"ShortName": "Floyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19069",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19071",
			"Name": "Fremont County",
			"ShortName": "Fremont",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19073",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19075",
			"Name": "Grundy County",
			"ShortName": "Grundy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19077",
			"Name": "Guthrie County",
			"ShortName": "Guthrie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19079",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19081",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19083",
			"Name": "Hardin County",
			"ShortName": "Hardin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19085",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19087",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19089",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19091",
			"Name": "Humboldt County",
			"ShortName": "Humboldt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19093",
			"Name": "Ida County",
			"ShortName": "Ida",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19095",
			"Name": "Iowa County",
			"ShortName": "Iowa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19097",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19099",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19101",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19103",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19105",
			"Name": "Jones County",
			"ShortName": "Jones",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19107",
			"Name": "Keokuk County",
			"ShortName": "Keokuk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19109",
			"Name": "Kossuth County",
			"ShortName": "Kossuth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19111",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19113",
			"Name": "Linn County",
			"ShortName": "Linn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19115",
			"Name": "Louisa County",
			"ShortName": "Louisa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19117",
			"Name": "Lucas County",
			"ShortName": "Lucas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19119",
			"Name": "Lyon County",
			"ShortName": "Lyon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19121",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19123",
			"Name": "Mahaska County",
			"ShortName": "Mahaska",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19125",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19127",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19129",
			"Name": "Mills County",
			"ShortName": "Mills",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19131",
			"Name": "Mitchell County",
			"ShortName": "Mitchell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19133",
			"Name": "Monona County",
			"ShortName": "Monona",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19135",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19137",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19139",
			"Name": "Muscatine County",
			"ShortName": "Muscatine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19141",
			"Name": "O'Brien County",
			"ShortName": "O'Brien",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19143",
			"Name": "Osceola County",
			"ShortName": "Osceola",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19145",
			"Name": "Page County",
			"ShortName": "Page",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19147",
			"Name": "Palo Alto County",
			"ShortName": "Palo Alto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19149",
			"Name": "Plymouth County",
			"ShortName": "Plymouth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19151",
			"Name": "Pocahontas County",
			"ShortName": "Pocahontas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19153",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19155",
			"Name": "Pottawattamie County",
			"ShortName": "Pottawattamie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19157",
			"Name": "Poweshiek County",
			"ShortName": "Poweshiek",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19159",
			"Name": "Ringgold County",
			"ShortName": "Ringgold",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19161",
			"Name": "Sac County",
			"ShortName": "Sac",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19163",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19165",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19167",
			"Name": "Sioux County",
			"ShortName": "Sioux",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19169",
			"Name": "Story County",
			"ShortName": "Story",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19171",
			"Name": "Tama County",
			"ShortName": "Tama",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19173",
			"Name": "Taylor County",
			"ShortName": "Taylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19175",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19177",
			"Name": "Van Buren County",
			"ShortName": "Van Buren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19179",
			"Name": "Wapello County",
			"ShortName": "Wapello",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19181",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19183",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19185",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19187",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19189",
			"Name": "Winnebago County",
			"ShortName": "Winnebago",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19191",
			"Name": "Winneshiek County",
			"ShortName": "Winneshiek",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19193",
			"Name": "Woodbury County",
			"ShortName": "Woodbury",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19195",
			"Name": "Worth County",
			"ShortName": "Worth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "19197",
			"Name": "Wright County",
			"ShortName": "Wright",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "20",
		"StateName": "Kansas",
		"Counties": [{
			"GeoId": "20001",
			"Name": "Allen County",
			"ShortName": "Allen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20003",
			"Name": "Anderson County",
			"ShortName": "Anderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20005",
			"Name": "Atchison County",
			"ShortName": "Atchison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20007",
			"Name": "Barber County",
			"ShortName": "Barber",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20009",
			"Name": "Barton County",
			"ShortName": "Barton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20011",
			"Name": "Bourbon County",
			"ShortName": "Bourbon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20013",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20015",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20017",
			"Name": "Chase County",
			"ShortName": "Chase",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20019",
			"Name": "Chautauqua County",
			"ShortName": "Chautauqua",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20021",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20023",
			"Name": "Cheyenne County",
			"ShortName": "Cheyenne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20025",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20027",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20029",
			"Name": "Cloud County",
			"ShortName": "Cloud",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20031",
			"Name": "Coffey County",
			"ShortName": "Coffey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20033",
			"Name": "Comanche County",
			"ShortName": "Comanche",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20035",
			"Name": "Cowley County",
			"ShortName": "Cowley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20037",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20039",
			"Name": "Decatur County",
			"ShortName": "Decatur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20041",
			"Name": "Dickinson County",
			"ShortName": "Dickinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20043",
			"Name": "Doniphan County",
			"ShortName": "Doniphan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20045",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20047",
			"Name": "Edwards County",
			"ShortName": "Edwards",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20049",
			"Name": "Elk County",
			"ShortName": "Elk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20051",
			"Name": "Ellis County",
			"ShortName": "Ellis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20053",
			"Name": "Ellsworth County",
			"ShortName": "Ellsworth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20055",
			"Name": "Finney County",
			"ShortName": "Finney",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20057",
			"Name": "Ford County",
			"ShortName": "Ford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20059",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20061",
			"Name": "Geary County",
			"ShortName": "Geary",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20063",
			"Name": "Gove County",
			"ShortName": "Gove",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20065",
			"Name": "Graham County",
			"ShortName": "Graham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20067",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20069",
			"Name": "Gray County",
			"ShortName": "Gray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20071",
			"Name": "Greeley County",
			"ShortName": "Greeley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20073",
			"Name": "Greenwood County",
			"ShortName": "Greenwood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20075",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20077",
			"Name": "Harper County",
			"ShortName": "Harper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20079",
			"Name": "Harvey County",
			"ShortName": "Harvey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20081",
			"Name": "Haskell County",
			"ShortName": "Haskell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20083",
			"Name": "Hodgeman County",
			"ShortName": "Hodgeman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20085",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20087",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20089",
			"Name": "Jewell County",
			"ShortName": "Jewell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20091",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20093",
			"Name": "Kearny County",
			"ShortName": "Kearny",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20095",
			"Name": "Kingman County",
			"ShortName": "Kingman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20097",
			"Name": "Kiowa County",
			"ShortName": "Kiowa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20099",
			"Name": "Labette County",
			"ShortName": "Labette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20101",
			"Name": "Lane County",
			"ShortName": "Lane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20103",
			"Name": "Leavenworth County",
			"ShortName": "Leavenworth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20105",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20107",
			"Name": "Linn County",
			"ShortName": "Linn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20109",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20111",
			"Name": "Lyon County",
			"ShortName": "Lyon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20115",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20117",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20113",
			"Name": "McPherson County",
			"ShortName": "McPherson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20119",
			"Name": "Meade County",
			"ShortName": "Meade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20121",
			"Name": "Miami County",
			"ShortName": "Miami",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20123",
			"Name": "Mitchell County",
			"ShortName": "Mitchell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20125",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20127",
			"Name": "Morris County",
			"ShortName": "Morris",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20129",
			"Name": "Morton County",
			"ShortName": "Morton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20131",
			"Name": "Nemaha County",
			"ShortName": "Nemaha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20133",
			"Name": "Neosho County",
			"ShortName": "Neosho",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20135",
			"Name": "Ness County",
			"ShortName": "Ness",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20137",
			"Name": "Norton County",
			"ShortName": "Norton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20139",
			"Name": "Osage County",
			"ShortName": "Osage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20141",
			"Name": "Osborne County",
			"ShortName": "Osborne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20143",
			"Name": "Ottawa County",
			"ShortName": "Ottawa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20145",
			"Name": "Pawnee County",
			"ShortName": "Pawnee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20147",
			"Name": "Phillips County",
			"ShortName": "Phillips",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20149",
			"Name": "Pottawatomie County",
			"ShortName": "Pottawatomie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20151",
			"Name": "Pratt County",
			"ShortName": "Pratt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20153",
			"Name": "Rawlins County",
			"ShortName": "Rawlins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20155",
			"Name": "Reno County",
			"ShortName": "Reno",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20157",
			"Name": "Republic County",
			"ShortName": "Republic",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20159",
			"Name": "Rice County",
			"ShortName": "Rice",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20161",
			"Name": "Riley County",
			"ShortName": "Riley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20163",
			"Name": "Rooks County",
			"ShortName": "Rooks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20165",
			"Name": "Rush County",
			"ShortName": "Rush",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20167",
			"Name": "Russell County",
			"ShortName": "Russell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20169",
			"Name": "Saline County",
			"ShortName": "Saline",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20171",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20173",
			"Name": "Sedgwick County",
			"ShortName": "Sedgwick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20175",
			"Name": "Seward County",
			"ShortName": "Seward",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20177",
			"Name": "Shawnee County",
			"ShortName": "Shawnee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20179",
			"Name": "Sheridan County",
			"ShortName": "Sheridan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20181",
			"Name": "Sherman County",
			"ShortName": "Sherman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20183",
			"Name": "Smith County",
			"ShortName": "Smith",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20185",
			"Name": "Stafford County",
			"ShortName": "Stafford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20187",
			"Name": "Stanton County",
			"ShortName": "Stanton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20189",
			"Name": "Stevens County",
			"ShortName": "Stevens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20191",
			"Name": "Sumner County",
			"ShortName": "Sumner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20193",
			"Name": "Thomas County",
			"ShortName": "Thomas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20195",
			"Name": "Trego County",
			"ShortName": "Trego",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20197",
			"Name": "Wabaunsee County",
			"ShortName": "Wabaunsee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20199",
			"Name": "Wallace County",
			"ShortName": "Wallace",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20201",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20203",
			"Name": "Wichita County",
			"ShortName": "Wichita",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20205",
			"Name": "Wilson County",
			"ShortName": "Wilson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20207",
			"Name": "Woodson County",
			"ShortName": "Woodson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "20209",
			"Name": "Wyandotte County",
			"ShortName": "Wyandotte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "21",
		"StateName": "Kentucky",
		"Counties": [{
			"GeoId": "21001",
			"Name": "Adair County",
			"ShortName": "Adair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21003",
			"Name": "Allen County",
			"ShortName": "Allen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21005",
			"Name": "Anderson County",
			"ShortName": "Anderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21007",
			"Name": "Ballard County",
			"ShortName": "Ballard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21009",
			"Name": "Barren County",
			"ShortName": "Barren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21011",
			"Name": "Bath County",
			"ShortName": "Bath",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21013",
			"Name": "Bell County",
			"ShortName": "Bell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21015",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21017",
			"Name": "Bourbon County",
			"ShortName": "Bourbon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21019",
			"Name": "Boyd County",
			"ShortName": "Boyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21021",
			"Name": "Boyle County",
			"ShortName": "Boyle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21023",
			"Name": "Bracken County",
			"ShortName": "Bracken",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21025",
			"Name": "Breathitt County",
			"ShortName": "Breathitt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21027",
			"Name": "Breckinridge County",
			"ShortName": "Breckinridge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21029",
			"Name": "Bullitt County",
			"ShortName": "Bullitt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21031",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21033",
			"Name": "Caldwell County",
			"ShortName": "Caldwell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21035",
			"Name": "Calloway County",
			"ShortName": "Calloway",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21037",
			"Name": "Campbell County",
			"ShortName": "Campbell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21039",
			"Name": "Carlisle County",
			"ShortName": "Carlisle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21041",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21043",
			"Name": "Carter County",
			"ShortName": "Carter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21045",
			"Name": "Casey County",
			"ShortName": "Casey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21047",
			"Name": "Christian County",
			"ShortName": "Christian",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21049",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21051",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21053",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21055",
			"Name": "Crittenden County",
			"ShortName": "Crittenden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21057",
			"Name": "Cumberland County",
			"ShortName": "Cumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21059",
			"Name": "Daviess County",
			"ShortName": "Daviess",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21061",
			"Name": "Edmonson County",
			"ShortName": "Edmonson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21063",
			"Name": "Elliott County",
			"ShortName": "Elliott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21065",
			"Name": "Estill County",
			"ShortName": "Estill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21067",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21069",
			"Name": "Fleming County",
			"ShortName": "Fleming",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21071",
			"Name": "Floyd County",
			"ShortName": "Floyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21073",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21075",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21077",
			"Name": "Gallatin County",
			"ShortName": "Gallatin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21079",
			"Name": "Garrard County",
			"ShortName": "Garrard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21081",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21083",
			"Name": "Graves County",
			"ShortName": "Graves",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21085",
			"Name": "Grayson County",
			"ShortName": "Grayson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21087",
			"Name": "Green County",
			"ShortName": "Green",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21089",
			"Name": "Greenup County",
			"ShortName": "Greenup",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21091",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21093",
			"Name": "Hardin County",
			"ShortName": "Hardin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21095",
			"Name": "Harlan County",
			"ShortName": "Harlan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21097",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21099",
			"Name": "Hart County",
			"ShortName": "Hart",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21101",
			"Name": "Henderson County",
			"ShortName": "Henderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21103",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21105",
			"Name": "Hickman County",
			"ShortName": "Hickman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21107",
			"Name": "Hopkins County",
			"ShortName": "Hopkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21109",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21111",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21113",
			"Name": "Jessamine County",
			"ShortName": "Jessamine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21115",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21117",
			"Name": "Kenton County",
			"ShortName": "Kenton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21119",
			"Name": "Knott County",
			"ShortName": "Knott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21121",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21123",
			"Name": "Larue County",
			"ShortName": "Larue",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21125",
			"Name": "Laurel County",
			"ShortName": "Laurel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21127",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21129",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21131",
			"Name": "Leslie County",
			"ShortName": "Leslie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21133",
			"Name": "Letcher County",
			"ShortName": "Letcher",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21135",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21137",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21139",
			"Name": "Livingston County",
			"ShortName": "Livingston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21141",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21143",
			"Name": "Lyon County",
			"ShortName": "Lyon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21151",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21153",
			"Name": "Magoffin County",
			"ShortName": "Magoffin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21155",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21157",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21159",
			"Name": "Martin County",
			"ShortName": "Martin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21161",
			"Name": "Mason County",
			"ShortName": "Mason",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21145",
			"Name": "McCracken County",
			"ShortName": "McCracken",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21147",
			"Name": "McCreary County",
			"ShortName": "McCreary",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21149",
			"Name": "McLean County",
			"ShortName": "McLean",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21163",
			"Name": "Meade County",
			"ShortName": "Meade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21165",
			"Name": "Menifee County",
			"ShortName": "Menifee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21167",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21169",
			"Name": "Metcalfe County",
			"ShortName": "Metcalfe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21171",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21173",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21175",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21177",
			"Name": "Muhlenberg County",
			"ShortName": "Muhlenberg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21179",
			"Name": "Nelson County",
			"ShortName": "Nelson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21181",
			"Name": "Nicholas County",
			"ShortName": "Nicholas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21183",
			"Name": "Ohio County",
			"ShortName": "Ohio",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21185",
			"Name": "Oldham County",
			"ShortName": "Oldham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21187",
			"Name": "Owen County",
			"ShortName": "Owen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21189",
			"Name": "Owsley County",
			"ShortName": "Owsley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21191",
			"Name": "Pendleton County",
			"ShortName": "Pendleton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21193",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21195",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21197",
			"Name": "Powell County",
			"ShortName": "Powell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21199",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21201",
			"Name": "Robertson County",
			"ShortName": "Robertson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21203",
			"Name": "Rockcastle County",
			"ShortName": "Rockcastle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21205",
			"Name": "Rowan County",
			"ShortName": "Rowan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21207",
			"Name": "Russell County",
			"ShortName": "Russell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21209",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21211",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21213",
			"Name": "Simpson County",
			"ShortName": "Simpson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21215",
			"Name": "Spencer County",
			"ShortName": "Spencer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21217",
			"Name": "Taylor County",
			"ShortName": "Taylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21219",
			"Name": "Todd County",
			"ShortName": "Todd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21221",
			"Name": "Trigg County",
			"ShortName": "Trigg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21223",
			"Name": "Trimble County",
			"ShortName": "Trimble",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21225",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21227",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21229",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21231",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21233",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21235",
			"Name": "Whitley County",
			"ShortName": "Whitley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21237",
			"Name": "Wolfe County",
			"ShortName": "Wolfe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "21239",
			"Name": "Woodford County",
			"ShortName": "Woodford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "22",
		"StateName": "Louisiana",
		"Counties": [{
			"GeoId": "22001",
			"Name": "Acadia County",
			"ShortName": "Acadia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22003",
			"Name": "Allen County",
			"ShortName": "Allen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22005",
			"Name": "Ascension County",
			"ShortName": "Ascension",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22007",
			"Name": "Assumption County",
			"ShortName": "Assumption",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22009",
			"Name": "Avoyelles County",
			"ShortName": "Avoyelles",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22011",
			"Name": "Beauregard County",
			"ShortName": "Beauregard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22013",
			"Name": "Bienville County",
			"ShortName": "Bienville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22015",
			"Name": "Bossier County",
			"ShortName": "Bossier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22017",
			"Name": "Caddo County",
			"ShortName": "Caddo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22019",
			"Name": "Calcasieu Parish County",
			"ShortName": "Calcasieu Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22021",
			"Name": "Caldwell County",
			"ShortName": "Caldwell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22023",
			"Name": "Cameron Parish County",
			"ShortName": "Cameron Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22025",
			"Name": "Catahoula County",
			"ShortName": "Catahoula",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22027",
			"Name": "Claiborne County",
			"ShortName": "Claiborne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22029",
			"Name": "Concordia County",
			"ShortName": "Concordia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22031",
			"Name": "De Soto County",
			"ShortName": "De Soto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22033",
			"Name": "East Baton Rouge County",
			"ShortName": "East Baton Rouge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22035",
			"Name": "East Carroll County",
			"ShortName": "East Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22037",
			"Name": "East Feliciana County",
			"ShortName": "East Feliciana",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22039",
			"Name": "Evangeline County",
			"ShortName": "Evangeline",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22041",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22043",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22045",
			"Name": "Iberia Parish County",
			"ShortName": "Iberia Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22047",
			"Name": "Iberville County",
			"ShortName": "Iberville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22049",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22053",
			"Name": "Jefferson Davis County",
			"ShortName": "Jefferson Davis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22051",
			"Name": "Jefferson Parish County",
			"ShortName": "Jefferson Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22059",
			"Name": "La Salle County",
			"ShortName": "La Salle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22055",
			"Name": "Lafayette County",
			"ShortName": "Lafayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22057",
			"Name": "Lafourche Parish County",
			"ShortName": "Lafourche Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22061",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22063",
			"Name": "Livingston Parish County",
			"ShortName": "Livingston Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22065",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22067",
			"Name": "Morehouse County",
			"ShortName": "Morehouse",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22069",
			"Name": "Natchitoches County",
			"ShortName": "Natchitoches",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22071",
			"Name": "Orleans Parish County",
			"ShortName": "Orleans Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22073",
			"Name": "Ouachita County",
			"ShortName": "Ouachita",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22075",
			"Name": "Plaquemines Parish County",
			"ShortName": "Plaquemines Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22077",
			"Name": "Pointe Coupee County",
			"ShortName": "Pointe Coupee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22079",
			"Name": "Rapides County",
			"ShortName": "Rapides",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22081",
			"Name": "Red River County",
			"ShortName": "Red River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22083",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22085",
			"Name": "Sabine County",
			"ShortName": "Sabine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22087",
			"Name": "St. Bernard Parish County",
			"ShortName": "St. Bernard Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22089",
			"Name": "St. Charles Parish County",
			"ShortName": "St. Charles Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22091",
			"Name": "St. Helena County",
			"ShortName": "St. Helena",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22093",
			"Name": "St. James Parish County",
			"ShortName": "St. James Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22095",
			"Name": "St. John the Baptist Parish County",
			"ShortName": "St. John the Baptist Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22097",
			"Name": "St. Landry County",
			"ShortName": "St. Landry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22099",
			"Name": "St. Martin Parish County",
			"ShortName": "St. Martin Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22101",
			"Name": "St. Mary Parish County",
			"ShortName": "St. Mary Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22103",
			"Name": "St. Tammany Parish County",
			"ShortName": "St. Tammany Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22105",
			"Name": "Tangipahoa Parish County",
			"ShortName": "Tangipahoa Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22107",
			"Name": "Tensas County",
			"ShortName": "Tensas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22109",
			"Name": "Terrebonne Parish County",
			"ShortName": "Terrebonne Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22111",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22113",
			"Name": "Vermilion Parish County",
			"ShortName": "Vermilion Parish",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22115",
			"Name": "Vernon County",
			"ShortName": "Vernon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22117",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22119",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22121",
			"Name": "West Baton Rouge County",
			"ShortName": "West Baton Rouge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22123",
			"Name": "West Carroll County",
			"ShortName": "West Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22125",
			"Name": "West Feliciana County",
			"ShortName": "West Feliciana",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "22127",
			"Name": "Winn County",
			"ShortName": "Winn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "23",
		"StateName": "Maine",
		"Counties": [{
			"GeoId": "23001",
			"Name": "Androscoggin County",
			"ShortName": "Androscoggin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23003",
			"Name": "Aroostook County",
			"ShortName": "Aroostook",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23005",
			"Name": "Cumberland County",
			"ShortName": "Cumberland County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23007",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23009",
			"Name": "Hancock County",
			"ShortName": "Hancock County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23011",
			"Name": "Kennebec County",
			"ShortName": "Kennebec",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23013",
			"Name": "Knox County",
			"ShortName": "Knox County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23015",
			"Name": "Lincoln County",
			"ShortName": "Lincoln County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23017",
			"Name": "Oxford County",
			"ShortName": "Oxford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23019",
			"Name": "Penobscot County",
			"ShortName": "Penobscot",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23021",
			"Name": "Piscataquis County",
			"ShortName": "Piscataquis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23023",
			"Name": "Sagadahoc County",
			"ShortName": "Sagadahoc County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23025",
			"Name": "Somerset County",
			"ShortName": "Somerset",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23027",
			"Name": "Waldo County",
			"ShortName": "Waldo County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23029",
			"Name": "Washington County",
			"ShortName": "Washington County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "23031",
			"Name": "York County",
			"ShortName": "York County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "24",
		"StateName": "Maryland",
		"Counties": [{
			"GeoId": "24001",
			"Name": "Allegany County",
			"ShortName": "Allegany",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24003",
			"Name": "Anne Arundel County",
			"ShortName": "Anne Arundel County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24510",
			"Name": "Baltimore City County",
			"ShortName": "Baltimore City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24005",
			"Name": "Baltimore County",
			"ShortName": "Baltimore County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24009",
			"Name": "Calvert County",
			"ShortName": "Calvert County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24011",
			"Name": "Caroline County",
			"ShortName": "Caroline County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24013",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24015",
			"Name": "Cecil County",
			"ShortName": "Cecil County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24017",
			"Name": "Charles County",
			"ShortName": "Charles County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24019",
			"Name": "Dorchester County",
			"ShortName": "Dorchester County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24021",
			"Name": "Frederick County",
			"ShortName": "Frederick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24023",
			"Name": "Garrett County",
			"ShortName": "Garrett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24025",
			"Name": "Harford County",
			"ShortName": "Harford County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24027",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24029",
			"Name": "Kent County",
			"ShortName": "Kent County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24031",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24033",
			"Name": "Prince George's County",
			"ShortName": "Prince George's County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24035",
			"Name": "Queen Anne's County",
			"ShortName": "Queen Anne's County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24039",
			"Name": "Somerset County",
			"ShortName": "Somerset County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24037",
			"Name": "St. Mary's County",
			"ShortName": "St. Mary's County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24041",
			"Name": "Talbot County",
			"ShortName": "Talbot County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24043",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24045",
			"Name": "Wicomico County",
			"ShortName": "Wicomico County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "24047",
			"Name": "Worcester County",
			"ShortName": "Worcester County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "25",
		"StateName": "Massachusetts",
		"Counties": [{
			"GeoId": "25001",
			"Name": "Barnstable County",
			"ShortName": "Barnstable County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25003",
			"Name": "Berkshire County",
			"ShortName": "Berkshire",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25005",
			"Name": "Bristol County",
			"ShortName": "Bristol County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25007",
			"Name": "Dukes County",
			"ShortName": "Dukes County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25009",
			"Name": "Essex County",
			"ShortName": "Essex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25011",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25013",
			"Name": "Hampden County",
			"ShortName": "Hampden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25015",
			"Name": "Hampshire County",
			"ShortName": "Hampshire",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25017",
			"Name": "Middlesex County",
			"ShortName": "Middlesex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25019",
			"Name": "Nantucket County",
			"ShortName": "Nantucket County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25021",
			"Name": "Norfolk County",
			"ShortName": "Norfolk County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25023",
			"Name": "Plymouth County",
			"ShortName": "Plymouth County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25025",
			"Name": "Suffolk County",
			"ShortName": "Suffolk County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "25027",
			"Name": "Worcester County",
			"ShortName": "Worcester",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "26",
		"StateName": "Michigan",
		"Counties": [{
			"GeoId": "26001",
			"Name": "Alcona County",
			"ShortName": "Alcona County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26003",
			"Name": "Alger County",
			"ShortName": "Alger County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26005",
			"Name": "Allegan County",
			"ShortName": "Allegan County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26007",
			"Name": "Alpena County",
			"ShortName": "Alpena County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26009",
			"Name": "Antrim County",
			"ShortName": "Antrim County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26011",
			"Name": "Arenac County",
			"ShortName": "Arenac County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26013",
			"Name": "Baraga County",
			"ShortName": "Baraga County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26015",
			"Name": "Barry County",
			"ShortName": "Barry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26017",
			"Name": "Bay County",
			"ShortName": "Bay County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26019",
			"Name": "Benzie County",
			"ShortName": "Benzie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26021",
			"Name": "Berrien County",
			"ShortName": "Berrien County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26023",
			"Name": "Branch County",
			"ShortName": "Branch",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26025",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26027",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26029",
			"Name": "Charlevoix County",
			"ShortName": "Charlevoix County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26031",
			"Name": "Cheboygan County",
			"ShortName": "Cheboygan County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26033",
			"Name": "Chippewa County",
			"ShortName": "Chippewa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26035",
			"Name": "Clare County",
			"ShortName": "Clare",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26037",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26039",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26041",
			"Name": "Delta County",
			"ShortName": "Delta County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26043",
			"Name": "Dickinson County",
			"ShortName": "Dickinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26045",
			"Name": "Eaton County",
			"ShortName": "Eaton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26047",
			"Name": "Emmet County",
			"ShortName": "Emmet County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26049",
			"Name": "Genesee County",
			"ShortName": "Genesee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26051",
			"Name": "Gladwin County",
			"ShortName": "Gladwin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26053",
			"Name": "Gogebic County",
			"ShortName": "Gogebic County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26055",
			"Name": "Grand Traverse County",
			"ShortName": "Grand Traverse County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26057",
			"Name": "Gratiot County",
			"ShortName": "Gratiot",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26059",
			"Name": "Hillsdale County",
			"ShortName": "Hillsdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26061",
			"Name": "Houghton County",
			"ShortName": "Houghton County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26063",
			"Name": "Huron County",
			"ShortName": "Huron County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26065",
			"Name": "Ingham County",
			"ShortName": "Ingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26067",
			"Name": "Ionia County",
			"ShortName": "Ionia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26069",
			"Name": "Iosco County",
			"ShortName": "Iosco County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26071",
			"Name": "Iron County",
			"ShortName": "Iron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26073",
			"Name": "Isabella County",
			"ShortName": "Isabella",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26075",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26077",
			"Name": "Kalamazoo County",
			"ShortName": "Kalamazoo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26079",
			"Name": "Kalkaska County",
			"ShortName": "Kalkaska",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26081",
			"Name": "Kent County",
			"ShortName": "Kent",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26083",
			"Name": "Keweenaw County",
			"ShortName": "Keweenaw County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26085",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26087",
			"Name": "Lapeer County",
			"ShortName": "Lapeer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26089",
			"Name": "Leelanau County",
			"ShortName": "Leelanau County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26091",
			"Name": "Lenawee County",
			"ShortName": "Lenawee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26093",
			"Name": "Livingston County",
			"ShortName": "Livingston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26095",
			"Name": "Luce County",
			"ShortName": "Luce County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26097",
			"Name": "Mackinac County",
			"ShortName": "Mackinac County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26099",
			"Name": "Macomb County",
			"ShortName": "Macomb County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26101",
			"Name": "Manistee County",
			"ShortName": "Manistee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26103",
			"Name": "Marquette County",
			"ShortName": "Marquette County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26105",
			"Name": "Mason County",
			"ShortName": "Mason County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26107",
			"Name": "Mecosta County",
			"ShortName": "Mecosta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26109",
			"Name": "Menominee County",
			"ShortName": "Menominee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26111",
			"Name": "Midland County",
			"ShortName": "Midland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26113",
			"Name": "Missaukee County",
			"ShortName": "Missaukee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26115",
			"Name": "Monroe County",
			"ShortName": "Monroe County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26117",
			"Name": "Montcalm County",
			"ShortName": "Montcalm",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26119",
			"Name": "Montmorency County",
			"ShortName": "Montmorency",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26121",
			"Name": "Muskegon County",
			"ShortName": "Muskegon County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26123",
			"Name": "Newaygo County",
			"ShortName": "Newaygo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26125",
			"Name": "Oakland County",
			"ShortName": "Oakland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26127",
			"Name": "Oceana County",
			"ShortName": "Oceana County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26129",
			"Name": "Ogemaw County",
			"ShortName": "Ogemaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26131",
			"Name": "Ontonagon County",
			"ShortName": "Ontonagon County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26133",
			"Name": "Osceola County",
			"ShortName": "Osceola",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26135",
			"Name": "Oscoda County",
			"ShortName": "Oscoda",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26137",
			"Name": "Otsego County",
			"ShortName": "Otsego",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26139",
			"Name": "Ottawa County",
			"ShortName": "Ottawa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26141",
			"Name": "Presque Isle County",
			"ShortName": "Presque Isle County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26143",
			"Name": "Roscommon County",
			"ShortName": "Roscommon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26145",
			"Name": "Saginaw County",
			"ShortName": "Saginaw County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26151",
			"Name": "Sanilac County",
			"ShortName": "Sanilac County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26153",
			"Name": "Schoolcraft County",
			"ShortName": "Schoolcraft County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26155",
			"Name": "Shiawassee County",
			"ShortName": "Shiawassee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26147",
			"Name": "St. Clair County",
			"ShortName": "St. Clair County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26149",
			"Name": "St. Joseph County",
			"ShortName": "St. Joseph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26157",
			"Name": "Tuscola County",
			"ShortName": "Tuscola County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26159",
			"Name": "Van Buren County",
			"ShortName": "Van Buren County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26161",
			"Name": "Washtenaw County",
			"ShortName": "Washtenaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26163",
			"Name": "Wayne County",
			"ShortName": "Wayne County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "26165",
			"Name": "Wexford County",
			"ShortName": "Wexford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "27",
		"StateName": "Minnesota",
		"Counties": [{
			"GeoId": "27001",
			"Name": "Aitkin County",
			"ShortName": "Aitkin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27003",
			"Name": "Anoka County",
			"ShortName": "Anoka",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27005",
			"Name": "Becker County",
			"ShortName": "Becker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27007",
			"Name": "Beltrami County",
			"ShortName": "Beltrami",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27009",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27011",
			"Name": "Big Stone County",
			"ShortName": "Big Stone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27013",
			"Name": "Blue Earth County",
			"ShortName": "Blue Earth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27015",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27017",
			"Name": "Carlton County",
			"ShortName": "Carlton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27019",
			"Name": "Carver County",
			"ShortName": "Carver",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27021",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27023",
			"Name": "Chippewa County",
			"ShortName": "Chippewa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27025",
			"Name": "Chisago County",
			"ShortName": "Chisago",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27027",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27029",
			"Name": "Clearwater County",
			"ShortName": "Clearwater",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27031",
			"Name": "Cook County",
			"ShortName": "Cook County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27033",
			"Name": "Cottonwood County",
			"ShortName": "Cottonwood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27035",
			"Name": "Crow Wing County",
			"ShortName": "Crow Wing",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27037",
			"Name": "Dakota County",
			"ShortName": "Dakota",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27039",
			"Name": "Dodge County",
			"ShortName": "Dodge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27041",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27043",
			"Name": "Faribault County",
			"ShortName": "Faribault",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27045",
			"Name": "Fillmore County",
			"ShortName": "Fillmore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27047",
			"Name": "Freeborn County",
			"ShortName": "Freeborn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27049",
			"Name": "Goodhue County",
			"ShortName": "Goodhue",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27051",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27053",
			"Name": "Hennepin County",
			"ShortName": "Hennepin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27055",
			"Name": "Houston County",
			"ShortName": "Houston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27057",
			"Name": "Hubbard County",
			"ShortName": "Hubbard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27059",
			"Name": "Isanti County",
			"ShortName": "Isanti",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27061",
			"Name": "Itasca County",
			"ShortName": "Itasca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27063",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27065",
			"Name": "Kanabec County",
			"ShortName": "Kanabec",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27067",
			"Name": "Kandiyohi County",
			"ShortName": "Kandiyohi",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27069",
			"Name": "Kittson County",
			"ShortName": "Kittson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27071",
			"Name": "Koochiching County",
			"ShortName": "Koochiching",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27073",
			"Name": "Lac qui Parle County",
			"ShortName": "Lac qui Parle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27075",
			"Name": "Lake County",
			"ShortName": "Lake County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27077",
			"Name": "Lake of the Woods County",
			"ShortName": "Lake of the Woods",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27079",
			"Name": "Le Sueur County",
			"ShortName": "Le Sueur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27081",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27083",
			"Name": "Lyon County",
			"ShortName": "Lyon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27087",
			"Name": "Mahnomen County",
			"ShortName": "Mahnomen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27089",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27091",
			"Name": "Martin County",
			"ShortName": "Martin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27085",
			"Name": "McLeod County",
			"ShortName": "McLeod",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27093",
			"Name": "Meeker County",
			"ShortName": "Meeker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27095",
			"Name": "Mille Lacs County",
			"ShortName": "Mille Lacs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27097",
			"Name": "Morrison County",
			"ShortName": "Morrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27099",
			"Name": "Mower County",
			"ShortName": "Mower",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27101",
			"Name": "Murray County",
			"ShortName": "Murray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27103",
			"Name": "Nicollet County",
			"ShortName": "Nicollet",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27105",
			"Name": "Nobles County",
			"ShortName": "Nobles",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27107",
			"Name": "Norman County",
			"ShortName": "Norman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27109",
			"Name": "Olmsted County",
			"ShortName": "Olmsted",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27111",
			"Name": "Otter Tail County",
			"ShortName": "Otter Tail",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27113",
			"Name": "Pennington County",
			"ShortName": "Pennington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27115",
			"Name": "Pine County",
			"ShortName": "Pine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27117",
			"Name": "Pipestone County",
			"ShortName": "Pipestone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27119",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27121",
			"Name": "Pope County",
			"ShortName": "Pope",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27123",
			"Name": "Ramsey County",
			"ShortName": "Ramsey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27125",
			"Name": "Red Lake County",
			"ShortName": "Red Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27127",
			"Name": "Redwood County",
			"ShortName": "Redwood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27129",
			"Name": "Renville County",
			"ShortName": "Renville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27131",
			"Name": "Rice County",
			"ShortName": "Rice",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27133",
			"Name": "Rock County",
			"ShortName": "Rock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27135",
			"Name": "Roseau County",
			"ShortName": "Roseau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27139",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27141",
			"Name": "Sherburne County",
			"ShortName": "Sherburne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27143",
			"Name": "Sibley County",
			"ShortName": "Sibley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27137",
			"Name": "St. Louis County",
			"ShortName": "St. Louis County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27145",
			"Name": "Stearns County",
			"ShortName": "Stearns",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27147",
			"Name": "Steele County",
			"ShortName": "Steele",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27149",
			"Name": "Stevens County",
			"ShortName": "Stevens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27151",
			"Name": "Swift County",
			"ShortName": "Swift",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27153",
			"Name": "Todd County",
			"ShortName": "Todd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27155",
			"Name": "Traverse County",
			"ShortName": "Traverse",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27157",
			"Name": "Wabasha County",
			"ShortName": "Wabasha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27159",
			"Name": "Wadena County",
			"ShortName": "Wadena",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27161",
			"Name": "Waseca County",
			"ShortName": "Waseca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27163",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27165",
			"Name": "Watonwan County",
			"ShortName": "Watonwan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27167",
			"Name": "Wilkin County",
			"ShortName": "Wilkin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27169",
			"Name": "Winona County",
			"ShortName": "Winona",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27171",
			"Name": "Wright County",
			"ShortName": "Wright",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "27173",
			"Name": "Yellow Medicine County",
			"ShortName": "Yellow Medicine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "28",
		"StateName": "Mississippi",
		"Counties": [{
			"GeoId": "28001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28003",
			"Name": "Alcorn County",
			"ShortName": "Alcorn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28005",
			"Name": "Amite County",
			"ShortName": "Amite",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28007",
			"Name": "Attala County",
			"ShortName": "Attala",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28009",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28011",
			"Name": "Bolivar County",
			"ShortName": "Bolivar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28013",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28015",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28017",
			"Name": "Chickasaw County",
			"ShortName": "Chickasaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28019",
			"Name": "Choctaw County",
			"ShortName": "Choctaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28021",
			"Name": "Claiborne County",
			"ShortName": "Claiborne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28023",
			"Name": "Clarke County",
			"ShortName": "Clarke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28025",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28027",
			"Name": "Coahoma County",
			"ShortName": "Coahoma",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28029",
			"Name": "Copiah County",
			"ShortName": "Copiah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28031",
			"Name": "Covington County",
			"ShortName": "Covington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28033",
			"Name": "DeSoto County",
			"ShortName": "DeSoto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28035",
			"Name": "Forrest County",
			"ShortName": "Forrest",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28037",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28039",
			"Name": "George County",
			"ShortName": "George",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28041",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28043",
			"Name": "Grenada County",
			"ShortName": "Grenada",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28045",
			"Name": "Hancock County",
			"ShortName": "Hancock County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28047",
			"Name": "Harrison County",
			"ShortName": "Harrison County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28049",
			"Name": "Hinds County",
			"ShortName": "Hinds",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28051",
			"Name": "Holmes County",
			"ShortName": "Holmes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28053",
			"Name": "Humphreys County",
			"ShortName": "Humphreys",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28055",
			"Name": "Issaquena County",
			"ShortName": "Issaquena",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28057",
			"Name": "Itawamba County",
			"ShortName": "Itawamba",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28059",
			"Name": "Jackson County",
			"ShortName": "Jackson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28061",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28063",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28065",
			"Name": "Jefferson Davis County",
			"ShortName": "Jefferson Davis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28067",
			"Name": "Jones County",
			"ShortName": "Jones",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28069",
			"Name": "Kemper County",
			"ShortName": "Kemper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28071",
			"Name": "Lafayette County",
			"ShortName": "Lafayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28073",
			"Name": "Lamar County",
			"ShortName": "Lamar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28075",
			"Name": "Lauderdale County",
			"ShortName": "Lauderdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28077",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28079",
			"Name": "Leake County",
			"ShortName": "Leake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28081",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28083",
			"Name": "Leflore County",
			"ShortName": "Leflore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28085",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28087",
			"Name": "Lowndes County",
			"ShortName": "Lowndes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28089",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28091",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28093",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28095",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28097",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28099",
			"Name": "Neshoba County",
			"ShortName": "Neshoba",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28101",
			"Name": "Newton County",
			"ShortName": "Newton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28103",
			"Name": "Noxubee County",
			"ShortName": "Noxubee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28105",
			"Name": "Oktibbeha County",
			"ShortName": "Oktibbeha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28107",
			"Name": "Panola County",
			"ShortName": "Panola",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28109",
			"Name": "Pearl River County",
			"ShortName": "Pearl River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28111",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28113",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28115",
			"Name": "Pontotoc County",
			"ShortName": "Pontotoc",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28117",
			"Name": "Prentiss County",
			"ShortName": "Prentiss",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28119",
			"Name": "Quitman County",
			"ShortName": "Quitman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28121",
			"Name": "Rankin County",
			"ShortName": "Rankin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28123",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28125",
			"Name": "Sharkey County",
			"ShortName": "Sharkey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28127",
			"Name": "Simpson County",
			"ShortName": "Simpson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28129",
			"Name": "Smith County",
			"ShortName": "Smith",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28131",
			"Name": "Stone County",
			"ShortName": "Stone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28133",
			"Name": "Sunflower County",
			"ShortName": "Sunflower",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28135",
			"Name": "Tallahatchie County",
			"ShortName": "Tallahatchie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28137",
			"Name": "Tate County",
			"ShortName": "Tate",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28139",
			"Name": "Tippah County",
			"ShortName": "Tippah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28141",
			"Name": "Tishomingo County",
			"ShortName": "Tishomingo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28143",
			"Name": "Tunica County",
			"ShortName": "Tunica",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28145",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28147",
			"Name": "Walthall County",
			"ShortName": "Walthall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28149",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28151",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28153",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28155",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28157",
			"Name": "Wilkinson County",
			"ShortName": "Wilkinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28159",
			"Name": "Winston County",
			"ShortName": "Winston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28161",
			"Name": "Yalobusha County",
			"ShortName": "Yalobusha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "28163",
			"Name": "Yazoo County",
			"ShortName": "Yazoo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "29",
		"StateName": "Missouri",
		"Counties": [{
			"GeoId": "29001",
			"Name": "Adair County",
			"ShortName": "Adair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29003",
			"Name": "Andrew County",
			"ShortName": "Andrew",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29005",
			"Name": "Atchison County",
			"ShortName": "Atchison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29007",
			"Name": "Audrain County",
			"ShortName": "Audrain",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29009",
			"Name": "Barry County",
			"ShortName": "Barry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29011",
			"Name": "Barton County",
			"ShortName": "Barton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29013",
			"Name": "Bates County",
			"ShortName": "Bates",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29015",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29017",
			"Name": "Bollinger County",
			"ShortName": "Bollinger",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29019",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29021",
			"Name": "Buchanan County",
			"ShortName": "Buchanan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29023",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29025",
			"Name": "Caldwell County",
			"ShortName": "Caldwell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29027",
			"Name": "Callaway County",
			"ShortName": "Callaway",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29029",
			"Name": "Camden County",
			"ShortName": "Camden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29031",
			"Name": "Cape Girardeau County",
			"ShortName": "Cape Girardeau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29033",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29035",
			"Name": "Carter County",
			"ShortName": "Carter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29037",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29039",
			"Name": "Cedar County",
			"ShortName": "Cedar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29041",
			"Name": "Chariton County",
			"ShortName": "Chariton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29043",
			"Name": "Christian County",
			"ShortName": "Christian",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29045",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29047",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29049",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29051",
			"Name": "Cole County",
			"ShortName": "Cole",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29053",
			"Name": "Cooper County",
			"ShortName": "Cooper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29055",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29057",
			"Name": "Dade County",
			"ShortName": "Dade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29059",
			"Name": "Dallas County",
			"ShortName": "Dallas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29061",
			"Name": "Daviess County",
			"ShortName": "Daviess",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29063",
			"Name": "DeKalb County",
			"ShortName": "DeKalb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29065",
			"Name": "Dent County",
			"ShortName": "Dent",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29067",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29069",
			"Name": "Dunklin County",
			"ShortName": "Dunklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29071",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29073",
			"Name": "Gasconade County",
			"ShortName": "Gasconade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29075",
			"Name": "Gentry County",
			"ShortName": "Gentry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29077",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29079",
			"Name": "Grundy County",
			"ShortName": "Grundy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29081",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29083",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29085",
			"Name": "Hickory County",
			"ShortName": "Hickory",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29087",
			"Name": "Holt County",
			"ShortName": "Holt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29089",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29091",
			"Name": "Howell County",
			"ShortName": "Howell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29093",
			"Name": "Iron County",
			"ShortName": "Iron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29095",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29097",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29099",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29101",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29103",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29105",
			"Name": "Laclede County",
			"ShortName": "Laclede",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29107",
			"Name": "Lafayette County",
			"ShortName": "Lafayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29109",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29111",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29113",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29115",
			"Name": "Linn County",
			"ShortName": "Linn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29117",
			"Name": "Livingston County",
			"ShortName": "Livingston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29121",
			"Name": "Macon County",
			"ShortName": "Macon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29123",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29125",
			"Name": "Maries County",
			"ShortName": "Maries",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29127",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29119",
			"Name": "McDonald County",
			"ShortName": "McDonald",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29129",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29131",
			"Name": "Miller County",
			"ShortName": "Miller",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29133",
			"Name": "Mississippi County",
			"ShortName": "Mississippi",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29135",
			"Name": "Moniteau County",
			"ShortName": "Moniteau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29137",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29139",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29141",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29143",
			"Name": "New Madrid County",
			"ShortName": "New Madrid",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29145",
			"Name": "Newton County",
			"ShortName": "Newton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29147",
			"Name": "Nodaway County",
			"ShortName": "Nodaway",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29149",
			"Name": "Oregon County",
			"ShortName": "Oregon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29151",
			"Name": "Osage County",
			"ShortName": "Osage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29153",
			"Name": "Ozark County",
			"ShortName": "Ozark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29155",
			"Name": "Pemiscot County",
			"ShortName": "Pemiscot",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29157",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29159",
			"Name": "Pettis County",
			"ShortName": "Pettis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29161",
			"Name": "Phelps County",
			"ShortName": "Phelps",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29163",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29165",
			"Name": "Platte County",
			"ShortName": "Platte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29167",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29169",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29171",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29173",
			"Name": "Ralls County",
			"ShortName": "Ralls",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29175",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29177",
			"Name": "Ray County",
			"ShortName": "Ray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29179",
			"Name": "Reynolds County",
			"ShortName": "Reynolds",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29181",
			"Name": "Ripley County",
			"ShortName": "Ripley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29195",
			"Name": "Saline County",
			"ShortName": "Saline",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29197",
			"Name": "Schuyler County",
			"ShortName": "Schuyler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29199",
			"Name": "Scotland County",
			"ShortName": "Scotland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29201",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29203",
			"Name": "Shannon County",
			"ShortName": "Shannon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29205",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29183",
			"Name": "St. Charles County",
			"ShortName": "St. Charles",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29185",
			"Name": "St. Clair County",
			"ShortName": "St. Clair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29187",
			"Name": "St. Francois County",
			"ShortName": "St. Francois",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29189",
			"Name": "St. Louis County",
			"ShortName": "St. Louis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29510",
			"Name": "St. Louis County",
			"ShortName": "St. Louis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29186",
			"Name": "Ste. Genevieve County",
			"ShortName": "Ste. Genevieve",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29207",
			"Name": "Stoddard County",
			"ShortName": "Stoddard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29209",
			"Name": "Stone County",
			"ShortName": "Stone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29211",
			"Name": "Sullivan County",
			"ShortName": "Sullivan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29213",
			"Name": "Taney County",
			"ShortName": "Taney",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29215",
			"Name": "Texas County",
			"ShortName": "Texas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29217",
			"Name": "Vernon County",
			"ShortName": "Vernon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29219",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29221",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29223",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29225",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29227",
			"Name": "Worth County",
			"ShortName": "Worth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "29229",
			"Name": "Wright County",
			"ShortName": "Wright",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "30",
		"StateName": "Montana",
		"Counties": [{
			"GeoId": "30001",
			"Name": "Beaverhead County",
			"ShortName": "Beaverhead",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30003",
			"Name": "Big Horn County",
			"ShortName": "Big Horn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30005",
			"Name": "Blaine County",
			"ShortName": "Blaine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30007",
			"Name": "Broadwater County",
			"ShortName": "Broadwater",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30009",
			"Name": "Carbon County",
			"ShortName": "Carbon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30011",
			"Name": "Carter County",
			"ShortName": "Carter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30013",
			"Name": "Cascade County",
			"ShortName": "Cascade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30015",
			"Name": "Chouteau County",
			"ShortName": "Chouteau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30017",
			"Name": "Custer County",
			"ShortName": "Custer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30019",
			"Name": "Daniels County",
			"ShortName": "Daniels",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30021",
			"Name": "Dawson County",
			"ShortName": "Dawson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30023",
			"Name": "Deer Lodge County",
			"ShortName": "Deer Lodge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30025",
			"Name": "Fallon County",
			"ShortName": "Fallon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30027",
			"Name": "Fergus County",
			"ShortName": "Fergus",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30029",
			"Name": "Flathead County",
			"ShortName": "Flathead",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30031",
			"Name": "Gallatin County",
			"ShortName": "Gallatin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30033",
			"Name": "Garfield County",
			"ShortName": "Garfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30035",
			"Name": "Glacier County",
			"ShortName": "Glacier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30037",
			"Name": "Golden Valley County",
			"ShortName": "Golden Valley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30039",
			"Name": "Granite County",
			"ShortName": "Granite",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30041",
			"Name": "Hill County",
			"ShortName": "Hill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30043",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30045",
			"Name": "Judith Basin County",
			"ShortName": "Judith Basin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30047",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30049",
			"Name": "Lewis and Clark County",
			"ShortName": "Lewis and Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30051",
			"Name": "Liberty County",
			"ShortName": "Liberty",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30053",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30057",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30055",
			"Name": "McCone County",
			"ShortName": "McCone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30059",
			"Name": "Meagher County",
			"ShortName": "Meagher",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30061",
			"Name": "Mineral County",
			"ShortName": "Mineral",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30063",
			"Name": "Missoula County",
			"ShortName": "Missoula",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30065",
			"Name": "Musselshell County",
			"ShortName": "Musselshell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30067",
			"Name": "Park County",
			"ShortName": "Park",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30069",
			"Name": "Petroleum County",
			"ShortName": "Petroleum",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30071",
			"Name": "Phillips County",
			"ShortName": "Phillips",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30073",
			"Name": "Pondera County",
			"ShortName": "Pondera",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30075",
			"Name": "Powder River County",
			"ShortName": "Powder River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30077",
			"Name": "Powell County",
			"ShortName": "Powell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30079",
			"Name": "Prairie County",
			"ShortName": "Prairie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30081",
			"Name": "Ravalli County",
			"ShortName": "Ravalli",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30083",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30085",
			"Name": "Roosevelt County",
			"ShortName": "Roosevelt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30087",
			"Name": "Rosebud County",
			"ShortName": "Rosebud",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30089",
			"Name": "Sanders County",
			"ShortName": "Sanders",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30091",
			"Name": "Sheridan County",
			"ShortName": "Sheridan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30093",
			"Name": "Silver Bow County",
			"ShortName": "Silver Bow",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30095",
			"Name": "Stillwater County",
			"ShortName": "Stillwater",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30097",
			"Name": "Sweet Grass County",
			"ShortName": "Sweet Grass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30099",
			"Name": "Teton County",
			"ShortName": "Teton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30101",
			"Name": "Toole County",
			"ShortName": "Toole",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30103",
			"Name": "Treasure County",
			"ShortName": "Treasure",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30105",
			"Name": "Valley County",
			"ShortName": "Valley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30107",
			"Name": "Wheatland County",
			"ShortName": "Wheatland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30109",
			"Name": "Wibaux County",
			"ShortName": "Wibaux",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "30111",
			"Name": "Yellowstone County",
			"ShortName": "Yellowstone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "31",
		"StateName": "Nebraska",
		"Counties": [{
			"GeoId": "31001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31003",
			"Name": "Antelope County",
			"ShortName": "Antelope",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31005",
			"Name": "Arthur County",
			"ShortName": "Arthur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31007",
			"Name": "Banner County",
			"ShortName": "Banner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31009",
			"Name": "Blaine County",
			"ShortName": "Blaine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31011",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31013",
			"Name": "Box Butte County",
			"ShortName": "Box Butte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31015",
			"Name": "Boyd County",
			"ShortName": "Boyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31017",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31019",
			"Name": "Buffalo County",
			"ShortName": "Buffalo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31021",
			"Name": "Burt County",
			"ShortName": "Burt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31023",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31025",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31027",
			"Name": "Cedar County",
			"ShortName": "Cedar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31029",
			"Name": "Chase County",
			"ShortName": "Chase",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31031",
			"Name": "Cherry County",
			"ShortName": "Cherry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31033",
			"Name": "Cheyenne County",
			"ShortName": "Cheyenne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31035",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31037",
			"Name": "Colfax County",
			"ShortName": "Colfax",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31039",
			"Name": "Cuming County",
			"ShortName": "Cuming",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31041",
			"Name": "Custer County",
			"ShortName": "Custer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31043",
			"Name": "Dakota County",
			"ShortName": "Dakota",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31045",
			"Name": "Dawes County",
			"ShortName": "Dawes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31047",
			"Name": "Dawson County",
			"ShortName": "Dawson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31049",
			"Name": "Deuel County",
			"ShortName": "Deuel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31051",
			"Name": "Dixon County",
			"ShortName": "Dixon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31053",
			"Name": "Dodge County",
			"ShortName": "Dodge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31055",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31057",
			"Name": "Dundy County",
			"ShortName": "Dundy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31059",
			"Name": "Fillmore County",
			"ShortName": "Fillmore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31061",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31063",
			"Name": "Frontier County",
			"ShortName": "Frontier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31065",
			"Name": "Furnas County",
			"ShortName": "Furnas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31067",
			"Name": "Gage County",
			"ShortName": "Gage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31069",
			"Name": "Garden County",
			"ShortName": "Garden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31071",
			"Name": "Garfield County",
			"ShortName": "Garfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31073",
			"Name": "Gosper County",
			"ShortName": "Gosper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31075",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31077",
			"Name": "Greeley County",
			"ShortName": "Greeley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31079",
			"Name": "Hall County",
			"ShortName": "Hall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31081",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31083",
			"Name": "Harlan County",
			"ShortName": "Harlan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31085",
			"Name": "Hayes County",
			"ShortName": "Hayes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31087",
			"Name": "Hitchcock County",
			"ShortName": "Hitchcock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31089",
			"Name": "Holt County",
			"ShortName": "Holt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31091",
			"Name": "Hooker County",
			"ShortName": "Hooker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31093",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31095",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31097",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31099",
			"Name": "Kearney County",
			"ShortName": "Kearney",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31101",
			"Name": "Keith County",
			"ShortName": "Keith",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31103",
			"Name": "Keya Paha County",
			"ShortName": "Keya Paha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31105",
			"Name": "Kimball County",
			"ShortName": "Kimball",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31107",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31109",
			"Name": "Lancaster County",
			"ShortName": "Lancaster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31111",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31113",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31115",
			"Name": "Loup County",
			"ShortName": "Loup",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31119",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31117",
			"Name": "McPherson County",
			"ShortName": "McPherson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31121",
			"Name": "Merrick County",
			"ShortName": "Merrick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31123",
			"Name": "Morrill County",
			"ShortName": "Morrill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31125",
			"Name": "Nance County",
			"ShortName": "Nance",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31127",
			"Name": "Nemaha County",
			"ShortName": "Nemaha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31129",
			"Name": "Nuckolls County",
			"ShortName": "Nuckolls",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31131",
			"Name": "Otoe County",
			"ShortName": "Otoe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31133",
			"Name": "Pawnee County",
			"ShortName": "Pawnee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31135",
			"Name": "Perkins County",
			"ShortName": "Perkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31137",
			"Name": "Phelps County",
			"ShortName": "Phelps",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31139",
			"Name": "Pierce County",
			"ShortName": "Pierce",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31141",
			"Name": "Platte County",
			"ShortName": "Platte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31143",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31145",
			"Name": "Red Willow County",
			"ShortName": "Red Willow",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31147",
			"Name": "Richardson County",
			"ShortName": "Richardson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31149",
			"Name": "Rock County",
			"ShortName": "Rock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31151",
			"Name": "Saline County",
			"ShortName": "Saline",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31153",
			"Name": "Sarpy County",
			"ShortName": "Sarpy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31155",
			"Name": "Saunders County",
			"ShortName": "Saunders",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31157",
			"Name": "Scotts Bluff County",
			"ShortName": "Scotts Bluff",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31159",
			"Name": "Seward County",
			"ShortName": "Seward",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31161",
			"Name": "Sheridan County",
			"ShortName": "Sheridan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31163",
			"Name": "Sherman County",
			"ShortName": "Sherman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31165",
			"Name": "Sioux County",
			"ShortName": "Sioux",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31167",
			"Name": "Stanton County",
			"ShortName": "Stanton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31169",
			"Name": "Thayer County",
			"ShortName": "Thayer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31171",
			"Name": "Thomas County",
			"ShortName": "Thomas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31173",
			"Name": "Thurston County",
			"ShortName": "Thurston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31175",
			"Name": "Valley County",
			"ShortName": "Valley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31177",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31179",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31181",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31183",
			"Name": "Wheeler County",
			"ShortName": "Wheeler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "31185",
			"Name": "York County",
			"ShortName": "York",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "32",
		"StateName": "Nevada",
		"Counties": [{
			"GeoId": "32510",
			"Name": "Carson City County",
			"ShortName": "Carson City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32001",
			"Name": "Churchill County",
			"ShortName": "Churchill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32003",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32005",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32007",
			"Name": "Elko County",
			"ShortName": "Elko",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32009",
			"Name": "Esmeralda County",
			"ShortName": "Esmeralda",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32011",
			"Name": "Eureka County",
			"ShortName": "Eureka",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32013",
			"Name": "Humboldt County",
			"ShortName": "Humboldt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32015",
			"Name": "Lander County",
			"ShortName": "Lander",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32017",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32019",
			"Name": "Lyon County",
			"ShortName": "Lyon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32021",
			"Name": "Mineral County",
			"ShortName": "Mineral",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32023",
			"Name": "Nye County",
			"ShortName": "Nye",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32027",
			"Name": "Pershing County",
			"ShortName": "Pershing",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32029",
			"Name": "Storey County",
			"ShortName": "Storey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32031",
			"Name": "Washoe County",
			"ShortName": "Washoe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "32033",
			"Name": "White Pine County",
			"ShortName": "White Pine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "33",
		"StateName": "New Hampshire",
		"Counties": [{
			"GeoId": "33001",
			"Name": "Belknap County",
			"ShortName": "Belknap",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33003",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33005",
			"Name": "Cheshire County",
			"ShortName": "Cheshire",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33007",
			"Name": "Coos County",
			"ShortName": "Coos",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33009",
			"Name": "Grafton County",
			"ShortName": "Grafton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33011",
			"Name": "Hillsborough County",
			"ShortName": "Hillsborough",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33013",
			"Name": "Merrimack County",
			"ShortName": "Merrimack",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33015",
			"Name": "Rockingham County",
			"ShortName": "Rockingham County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33017",
			"Name": "Strafford County",
			"ShortName": "Strafford County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "33019",
			"Name": "Sullivan County",
			"ShortName": "Sullivan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "34",
		"StateName": "New Jersey",
		"Counties": [{
			"GeoId": "34001",
			"Name": "Atlantic County",
			"ShortName": "Atlantic County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34003",
			"Name": "Bergen County",
			"ShortName": "Bergen County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34005",
			"Name": "Burlington County",
			"ShortName": "Burlington County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34007",
			"Name": "Camden County",
			"ShortName": "Camden County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34009",
			"Name": "Cape May County",
			"ShortName": "Cape May County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34011",
			"Name": "Cumberland County",
			"ShortName": "Cumberland County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34013",
			"Name": "Essex County",
			"ShortName": "Essex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34015",
			"Name": "Gloucester County",
			"ShortName": "Gloucester County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34017",
			"Name": "Hudson County",
			"ShortName": "Hudson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34019",
			"Name": "Hunterdon County",
			"ShortName": "Hunterdon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34021",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34023",
			"Name": "Middlesex County",
			"ShortName": "Middlesex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34025",
			"Name": "Monmouth County",
			"ShortName": "Monmouth County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34027",
			"Name": "Morris County",
			"ShortName": "Morris",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34029",
			"Name": "Ocean County",
			"ShortName": "Ocean County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34031",
			"Name": "Passaic County",
			"ShortName": "Passaic",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34033",
			"Name": "Salem County",
			"ShortName": "Salem County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34035",
			"Name": "Somerset County",
			"ShortName": "Somerset County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34037",
			"Name": "Sussex County",
			"ShortName": "Sussex",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34039",
			"Name": "Union County",
			"ShortName": "Union County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "34041",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "35",
		"StateName": "New Mexico",
		"Counties": [{
			"GeoId": "35001",
			"Name": "Bernalillo County",
			"ShortName": "Bernalillo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35003",
			"Name": "Catron County",
			"ShortName": "Catron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35005",
			"Name": "Chaves County",
			"ShortName": "Chaves",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35006",
			"Name": "Cibola County",
			"ShortName": "Cibola",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35007",
			"Name": "Colfax County",
			"ShortName": "Colfax",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35009",
			"Name": "Curry County",
			"ShortName": "Curry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35011",
			"Name": "De Baca County",
			"ShortName": "De Baca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35013",
			"Name": "Doña Ana County",
			"ShortName": "Doña Ana",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35015",
			"Name": "Eddy County",
			"ShortName": "Eddy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35017",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35019",
			"Name": "Guadalupe County",
			"ShortName": "Guadalupe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35021",
			"Name": "Harding County",
			"ShortName": "Harding",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35023",
			"Name": "Hidalgo County",
			"ShortName": "Hidalgo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35025",
			"Name": "Lea County",
			"ShortName": "Lea",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35027",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35028",
			"Name": "Los Alamos County",
			"ShortName": "Los Alamos",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35029",
			"Name": "Luna County",
			"ShortName": "Luna",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35031",
			"Name": "McKinley County",
			"ShortName": "McKinley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35033",
			"Name": "Mora County",
			"ShortName": "Mora",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35035",
			"Name": "Otero County",
			"ShortName": "Otero",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35037",
			"Name": "Quay County",
			"ShortName": "Quay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35039",
			"Name": "Rio Arriba County",
			"ShortName": "Rio Arriba",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35041",
			"Name": "Roosevelt County",
			"ShortName": "Roosevelt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35045",
			"Name": "San Juan County",
			"ShortName": "San Juan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35047",
			"Name": "San Miguel County",
			"ShortName": "San Miguel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35043",
			"Name": "Sandoval County",
			"ShortName": "Sandoval",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35049",
			"Name": "Santa Fe County",
			"ShortName": "Santa Fe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35051",
			"Name": "Sierra County",
			"ShortName": "Sierra",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35053",
			"Name": "Socorro County",
			"ShortName": "Socorro",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35055",
			"Name": "Taos County",
			"ShortName": "Taos",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35057",
			"Name": "Torrance County",
			"ShortName": "Torrance",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35059",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "35061",
			"Name": "Valencia County",
			"ShortName": "Valencia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "36",
		"StateName": "New York",
		"Counties": [{
			"GeoId": "36001",
			"Name": "Albany County",
			"ShortName": "Albany County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36003",
			"Name": "Allegany County",
			"ShortName": "Allegany",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36005",
			"Name": "Bronx County",
			"ShortName": "Bronx County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36007",
			"Name": "Broome County",
			"ShortName": "Broome",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36009",
			"Name": "Cattaraugus County",
			"ShortName": "Cattaraugus",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36011",
			"Name": "Cayuga County",
			"ShortName": "Cayuga County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36013",
			"Name": "Chautauqua County",
			"ShortName": "Chautauqua County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36015",
			"Name": "Chemung County",
			"ShortName": "Chemung",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36017",
			"Name": "Chenango County",
			"ShortName": "Chenango",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36019",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36021",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36023",
			"Name": "Cortland County",
			"ShortName": "Cortland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36025",
			"Name": "Delaware County",
			"ShortName": "Delaware",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36027",
			"Name": "Dutchess County",
			"ShortName": "Dutchess County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36029",
			"Name": "Erie County",
			"ShortName": "Erie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36031",
			"Name": "Essex County",
			"ShortName": "Essex",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36033",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36035",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36037",
			"Name": "Genesee County",
			"ShortName": "Genesee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36039",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36041",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36043",
			"Name": "Herkimer County",
			"ShortName": "Herkimer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36045",
			"Name": "Jefferson County",
			"ShortName": "Jefferson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36047",
			"Name": "Kings County",
			"ShortName": "Kings County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36049",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36051",
			"Name": "Livingston County",
			"ShortName": "Livingston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36053",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36055",
			"Name": "Monroe County",
			"ShortName": "Monroe County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36057",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36059",
			"Name": "Nassau County",
			"ShortName": "Nassau County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36061",
			"Name": "New York County",
			"ShortName": "New York County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36063",
			"Name": "Niagara County",
			"ShortName": "Niagara County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36065",
			"Name": "Oneida County",
			"ShortName": "Oneida",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36067",
			"Name": "Onondaga County",
			"ShortName": "Onondaga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36069",
			"Name": "Ontario County",
			"ShortName": "Ontario",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36071",
			"Name": "Orange County",
			"ShortName": "Orange County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36073",
			"Name": "Orleans County",
			"ShortName": "Orleans County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36075",
			"Name": "Oswego County",
			"ShortName": "Oswego County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36077",
			"Name": "Otsego County",
			"ShortName": "Otsego",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36079",
			"Name": "Putnam County",
			"ShortName": "Putnam County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36081",
			"Name": "Queens County",
			"ShortName": "Queens County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36083",
			"Name": "Rensselaer County",
			"ShortName": "Rensselaer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36085",
			"Name": "Richmond County",
			"ShortName": "Richmond County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36087",
			"Name": "Rockland County",
			"ShortName": "Rockland County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36091",
			"Name": "Saratoga County",
			"ShortName": "Saratoga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36093",
			"Name": "Schenectady County",
			"ShortName": "Schenectady",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36095",
			"Name": "Schoharie County",
			"ShortName": "Schoharie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36097",
			"Name": "Schuyler County",
			"ShortName": "Schuyler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36099",
			"Name": "Seneca County",
			"ShortName": "Seneca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36089",
			"Name": "St. Lawrence County",
			"ShortName": "St. Lawrence County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36101",
			"Name": "Steuben County",
			"ShortName": "Steuben",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36103",
			"Name": "Suffolk County",
			"ShortName": "Suffolk County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36105",
			"Name": "Sullivan County",
			"ShortName": "Sullivan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36107",
			"Name": "Tioga County",
			"ShortName": "Tioga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36109",
			"Name": "Tompkins County",
			"ShortName": "Tompkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36111",
			"Name": "Ulster County",
			"ShortName": "Ulster County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36113",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36115",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36117",
			"Name": "Wayne County",
			"ShortName": "Wayne County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36119",
			"Name": "Westchester County",
			"ShortName": "Westchester County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36121",
			"Name": "Wyoming County",
			"ShortName": "Wyoming",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "36123",
			"Name": "Yates County",
			"ShortName": "Yates",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "37",
		"StateName": "North Carolina",
		"Counties": [{
			"GeoId": "37001",
			"Name": "Alamance County",
			"ShortName": "Alamance",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37003",
			"Name": "Alexander County",
			"ShortName": "Alexander",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37005",
			"Name": "Alleghany County",
			"ShortName": "Alleghany",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37007",
			"Name": "Anson County",
			"ShortName": "Anson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37009",
			"Name": "Ashe County",
			"ShortName": "Ashe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37011",
			"Name": "Avery County",
			"ShortName": "Avery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37013",
			"Name": "Beaufort County",
			"ShortName": "Beaufort County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37015",
			"Name": "Bertie County",
			"ShortName": "Bertie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37017",
			"Name": "Bladen County",
			"ShortName": "Bladen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37019",
			"Name": "Brunswick County",
			"ShortName": "Brunswick County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37021",
			"Name": "Buncombe County",
			"ShortName": "Buncombe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37023",
			"Name": "Burke County",
			"ShortName": "Burke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37025",
			"Name": "Cabarrus County",
			"ShortName": "Cabarrus",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37027",
			"Name": "Caldwell County",
			"ShortName": "Caldwell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37029",
			"Name": "Camden County",
			"ShortName": "Camden County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37031",
			"Name": "Carteret County",
			"ShortName": "Carteret County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37033",
			"Name": "Caswell County",
			"ShortName": "Caswell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37035",
			"Name": "Catawba County",
			"ShortName": "Catawba",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37037",
			"Name": "Chatham County",
			"ShortName": "Chatham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37039",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37041",
			"Name": "Chowan County",
			"ShortName": "Chowan County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37043",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37045",
			"Name": "Cleveland County",
			"ShortName": "Cleveland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37047",
			"Name": "Columbus County",
			"ShortName": "Columbus",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37049",
			"Name": "Craven County",
			"ShortName": "Craven County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37051",
			"Name": "Cumberland County",
			"ShortName": "Cumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37053",
			"Name": "Currituck County",
			"ShortName": "Currituck County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37055",
			"Name": "Dare County",
			"ShortName": "Dare County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37057",
			"Name": "Davidson County",
			"ShortName": "Davidson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37059",
			"Name": "Davie County",
			"ShortName": "Davie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37061",
			"Name": "Duplin County",
			"ShortName": "Duplin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37063",
			"Name": "Durham County",
			"ShortName": "Durham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37065",
			"Name": "Edgecombe County",
			"ShortName": "Edgecombe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37067",
			"Name": "Forsyth County",
			"ShortName": "Forsyth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37069",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37071",
			"Name": "Gaston County",
			"ShortName": "Gaston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37073",
			"Name": "Gates County",
			"ShortName": "Gates County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37075",
			"Name": "Graham County",
			"ShortName": "Graham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37077",
			"Name": "Granville County",
			"ShortName": "Granville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37079",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37081",
			"Name": "Guilford County",
			"ShortName": "Guilford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37083",
			"Name": "Halifax County",
			"ShortName": "Halifax",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37085",
			"Name": "Harnett County",
			"ShortName": "Harnett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37087",
			"Name": "Haywood County",
			"ShortName": "Haywood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37089",
			"Name": "Henderson County",
			"ShortName": "Henderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37091",
			"Name": "Hertford County",
			"ShortName": "Hertford County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37093",
			"Name": "Hoke County",
			"ShortName": "Hoke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37095",
			"Name": "Hyde County",
			"ShortName": "Hyde County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37097",
			"Name": "Iredell County",
			"ShortName": "Iredell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37099",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37101",
			"Name": "Johnston County",
			"ShortName": "Johnston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37103",
			"Name": "Jones County",
			"ShortName": "Jones",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37105",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37107",
			"Name": "Lenoir County",
			"ShortName": "Lenoir",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37109",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37113",
			"Name": "Macon County",
			"ShortName": "Macon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37115",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37117",
			"Name": "Martin County",
			"ShortName": "Martin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37111",
			"Name": "McDowell County",
			"ShortName": "McDowell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37119",
			"Name": "Mecklenburg County",
			"ShortName": "Mecklenburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37121",
			"Name": "Mitchell County",
			"ShortName": "Mitchell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37123",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37125",
			"Name": "Moore County",
			"ShortName": "Moore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37127",
			"Name": "Nash County",
			"ShortName": "Nash",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37129",
			"Name": "New Hanover County",
			"ShortName": "New Hanover County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37131",
			"Name": "Northampton County",
			"ShortName": "Northampton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37133",
			"Name": "Onslow County",
			"ShortName": "Onslow County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37135",
			"Name": "Orange County",
			"ShortName": "Orange",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37137",
			"Name": "Pamlico County",
			"ShortName": "Pamlico County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37139",
			"Name": "Pasquotank County",
			"ShortName": "Pasquotank County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37141",
			"Name": "Pender County",
			"ShortName": "Pender County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37143",
			"Name": "Perquimans County",
			"ShortName": "Perquimans County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37145",
			"Name": "Person County",
			"ShortName": "Person",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37147",
			"Name": "Pitt County",
			"ShortName": "Pitt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37149",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37151",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37153",
			"Name": "Richmond County",
			"ShortName": "Richmond",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37155",
			"Name": "Robeson County",
			"ShortName": "Robeson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37157",
			"Name": "Rockingham County",
			"ShortName": "Rockingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37159",
			"Name": "Rowan County",
			"ShortName": "Rowan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37161",
			"Name": "Rutherford County",
			"ShortName": "Rutherford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37163",
			"Name": "Sampson County",
			"ShortName": "Sampson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37165",
			"Name": "Scotland County",
			"ShortName": "Scotland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37167",
			"Name": "Stanly County",
			"ShortName": "Stanly",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37169",
			"Name": "Stokes County",
			"ShortName": "Stokes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37171",
			"Name": "Surry County",
			"ShortName": "Surry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37173",
			"Name": "Swain County",
			"ShortName": "Swain",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37175",
			"Name": "Transylvania County",
			"ShortName": "Transylvania",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37177",
			"Name": "Tyrrell County",
			"ShortName": "Tyrrell County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37179",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37181",
			"Name": "Vance County",
			"ShortName": "Vance",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37183",
			"Name": "Wake County",
			"ShortName": "Wake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37185",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37187",
			"Name": "Washington County",
			"ShortName": "Washington County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37189",
			"Name": "Watauga County",
			"ShortName": "Watauga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37191",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37193",
			"Name": "Wilkes County",
			"ShortName": "Wilkes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37195",
			"Name": "Wilson County",
			"ShortName": "Wilson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37197",
			"Name": "Yadkin County",
			"ShortName": "Yadkin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "37199",
			"Name": "Yancey County",
			"ShortName": "Yancey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "38",
		"StateName": "North Dakota",
		"Counties": [{
			"GeoId": "38001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38003",
			"Name": "Barnes County",
			"ShortName": "Barnes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38005",
			"Name": "Benson County",
			"ShortName": "Benson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38007",
			"Name": "Billings County",
			"ShortName": "Billings",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38009",
			"Name": "Bottineau County",
			"ShortName": "Bottineau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38011",
			"Name": "Bowman County",
			"ShortName": "Bowman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38013",
			"Name": "Burke County",
			"ShortName": "Burke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38015",
			"Name": "Burleigh County",
			"ShortName": "Burleigh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38017",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38019",
			"Name": "Cavalier County",
			"ShortName": "Cavalier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38021",
			"Name": "Dickey County",
			"ShortName": "Dickey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38023",
			"Name": "Divide County",
			"ShortName": "Divide",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38025",
			"Name": "Dunn County",
			"ShortName": "Dunn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38027",
			"Name": "Eddy County",
			"ShortName": "Eddy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38029",
			"Name": "Emmons County",
			"ShortName": "Emmons",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38031",
			"Name": "Foster County",
			"ShortName": "Foster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38033",
			"Name": "Golden Valley County",
			"ShortName": "Golden Valley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38035",
			"Name": "Grand Forks County",
			"ShortName": "Grand Forks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38037",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38039",
			"Name": "Griggs County",
			"ShortName": "Griggs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38041",
			"Name": "Hettinger County",
			"ShortName": "Hettinger",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38043",
			"Name": "Kidder County",
			"ShortName": "Kidder",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38045",
			"Name": "LaMoure County",
			"ShortName": "LaMoure",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38047",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38049",
			"Name": "McHenry County",
			"ShortName": "McHenry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38051",
			"Name": "McIntosh County",
			"ShortName": "McIntosh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38053",
			"Name": "McKenzie County",
			"ShortName": "McKenzie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38055",
			"Name": "McLean County",
			"ShortName": "McLean",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38057",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38059",
			"Name": "Morton County",
			"ShortName": "Morton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38061",
			"Name": "Mountrail County",
			"ShortName": "Mountrail",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38063",
			"Name": "Nelson County",
			"ShortName": "Nelson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38065",
			"Name": "Oliver County",
			"ShortName": "Oliver",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38067",
			"Name": "Pembina County",
			"ShortName": "Pembina",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38069",
			"Name": "Pierce County",
			"ShortName": "Pierce",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38071",
			"Name": "Ramsey County",
			"ShortName": "Ramsey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38073",
			"Name": "Ransom County",
			"ShortName": "Ransom",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38075",
			"Name": "Renville County",
			"ShortName": "Renville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38077",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38079",
			"Name": "Rolette County",
			"ShortName": "Rolette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38081",
			"Name": "Sargent County",
			"ShortName": "Sargent",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38083",
			"Name": "Sheridan County",
			"ShortName": "Sheridan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38085",
			"Name": "Sioux County",
			"ShortName": "Sioux",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38087",
			"Name": "Slope County",
			"ShortName": "Slope",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38089",
			"Name": "Stark County",
			"ShortName": "Stark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38091",
			"Name": "Steele County",
			"ShortName": "Steele",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38093",
			"Name": "Stutsman County",
			"ShortName": "Stutsman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38095",
			"Name": "Towner County",
			"ShortName": "Towner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38097",
			"Name": "Traill County",
			"ShortName": "Traill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38099",
			"Name": "Walsh County",
			"ShortName": "Walsh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38101",
			"Name": "Ward County",
			"ShortName": "Ward",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38103",
			"Name": "Wells County",
			"ShortName": "Wells",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "38105",
			"Name": "Williams County",
			"ShortName": "Williams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "39",
		"StateName": "Ohio",
		"Counties": [{
			"GeoId": "39001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39003",
			"Name": "Allen County",
			"ShortName": "Allen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39005",
			"Name": "Ashland County",
			"ShortName": "Ashland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39007",
			"Name": "Ashtabula County",
			"ShortName": "Ashtabula County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39009",
			"Name": "Athens County",
			"ShortName": "Athens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39011",
			"Name": "Auglaize County",
			"ShortName": "Auglaize",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39013",
			"Name": "Belmont County",
			"ShortName": "Belmont",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39015",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39017",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39019",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39021",
			"Name": "Champaign County",
			"ShortName": "Champaign",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39023",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39025",
			"Name": "Clermont County",
			"ShortName": "Clermont",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39027",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39029",
			"Name": "Columbiana County",
			"ShortName": "Columbiana",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39031",
			"Name": "Coshocton County",
			"ShortName": "Coshocton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39033",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39035",
			"Name": "Cuyahoga County",
			"ShortName": "Cuyahoga County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39037",
			"Name": "Darke County",
			"ShortName": "Darke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39039",
			"Name": "Defiance County",
			"ShortName": "Defiance",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39041",
			"Name": "Delaware County",
			"ShortName": "Delaware",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39043",
			"Name": "Erie County",
			"ShortName": "Erie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39045",
			"Name": "Fairfield County",
			"ShortName": "Fairfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39047",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39049",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39051",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39053",
			"Name": "Gallia County",
			"ShortName": "Gallia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39055",
			"Name": "Geauga County",
			"ShortName": "Geauga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39057",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39059",
			"Name": "Guernsey County",
			"ShortName": "Guernsey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39061",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39063",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39065",
			"Name": "Hardin County",
			"ShortName": "Hardin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39067",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39069",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39071",
			"Name": "Highland County",
			"ShortName": "Highland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39073",
			"Name": "Hocking County",
			"ShortName": "Hocking",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39075",
			"Name": "Holmes County",
			"ShortName": "Holmes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39077",
			"Name": "Huron County",
			"ShortName": "Huron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39079",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39081",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39083",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39085",
			"Name": "Lake County",
			"ShortName": "Lake County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39087",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39089",
			"Name": "Licking County",
			"ShortName": "Licking",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39091",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39093",
			"Name": "Lorain County",
			"ShortName": "Lorain County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39095",
			"Name": "Lucas County",
			"ShortName": "Lucas County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39097",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39099",
			"Name": "Mahoning County",
			"ShortName": "Mahoning",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39101",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39103",
			"Name": "Medina County",
			"ShortName": "Medina",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39105",
			"Name": "Meigs County",
			"ShortName": "Meigs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39107",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39109",
			"Name": "Miami County",
			"ShortName": "Miami",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39111",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39113",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39115",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39117",
			"Name": "Morrow County",
			"ShortName": "Morrow",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39119",
			"Name": "Muskingum County",
			"ShortName": "Muskingum",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39121",
			"Name": "Noble County",
			"ShortName": "Noble",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39123",
			"Name": "Ottawa County",
			"ShortName": "Ottawa County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39125",
			"Name": "Paulding County",
			"ShortName": "Paulding",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39127",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39129",
			"Name": "Pickaway County",
			"ShortName": "Pickaway",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39131",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39133",
			"Name": "Portage County",
			"ShortName": "Portage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39135",
			"Name": "Preble County",
			"ShortName": "Preble",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39137",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39139",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39141",
			"Name": "Ross County",
			"ShortName": "Ross",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39143",
			"Name": "Sandusky County",
			"ShortName": "Sandusky County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39145",
			"Name": "Scioto County",
			"ShortName": "Scioto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39147",
			"Name": "Seneca County",
			"ShortName": "Seneca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39149",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39151",
			"Name": "Stark County",
			"ShortName": "Stark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39153",
			"Name": "Summit County",
			"ShortName": "Summit",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39155",
			"Name": "Trumbull County",
			"ShortName": "Trumbull",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39157",
			"Name": "Tuscarawas County",
			"ShortName": "Tuscarawas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39159",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39161",
			"Name": "Van Wert County",
			"ShortName": "Van Wert",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39163",
			"Name": "Vinton County",
			"ShortName": "Vinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39165",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39167",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39169",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39171",
			"Name": "Williams County",
			"ShortName": "Williams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39173",
			"Name": "Wood County",
			"ShortName": "Wood County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "39175",
			"Name": "Wyandot County",
			"ShortName": "Wyandot",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "40",
		"StateName": "Oklahoma",
		"Counties": [{
			"GeoId": "40001",
			"Name": "Adair County",
			"ShortName": "Adair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40003",
			"Name": "Alfalfa County",
			"ShortName": "Alfalfa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40005",
			"Name": "Atoka County",
			"ShortName": "Atoka",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40007",
			"Name": "Beaver County",
			"ShortName": "Beaver",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40009",
			"Name": "Beckham County",
			"ShortName": "Beckham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40011",
			"Name": "Blaine County",
			"ShortName": "Blaine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40013",
			"Name": "Bryan County",
			"ShortName": "Bryan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40015",
			"Name": "Caddo County",
			"ShortName": "Caddo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40017",
			"Name": "Canadian County",
			"ShortName": "Canadian",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40019",
			"Name": "Carter County",
			"ShortName": "Carter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40021",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40023",
			"Name": "Choctaw County",
			"ShortName": "Choctaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40025",
			"Name": "Cimarron County",
			"ShortName": "Cimarron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40027",
			"Name": "Cleveland County",
			"ShortName": "Cleveland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40029",
			"Name": "Coal County",
			"ShortName": "Coal",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40031",
			"Name": "Comanche County",
			"ShortName": "Comanche",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40033",
			"Name": "Cotton County",
			"ShortName": "Cotton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40035",
			"Name": "Craig County",
			"ShortName": "Craig",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40037",
			"Name": "Creek County",
			"ShortName": "Creek",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40039",
			"Name": "Custer County",
			"ShortName": "Custer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40041",
			"Name": "Delaware County",
			"ShortName": "Delaware",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40043",
			"Name": "Dewey County",
			"ShortName": "Dewey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40045",
			"Name": "Ellis County",
			"ShortName": "Ellis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40047",
			"Name": "Garfield County",
			"ShortName": "Garfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40049",
			"Name": "Garvin County",
			"ShortName": "Garvin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40051",
			"Name": "Grady County",
			"ShortName": "Grady",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40053",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40055",
			"Name": "Greer County",
			"ShortName": "Greer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40057",
			"Name": "Harmon County",
			"ShortName": "Harmon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40059",
			"Name": "Harper County",
			"ShortName": "Harper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40061",
			"Name": "Haskell County",
			"ShortName": "Haskell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40063",
			"Name": "Hughes County",
			"ShortName": "Hughes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40065",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40067",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40069",
			"Name": "Johnston County",
			"ShortName": "Johnston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40071",
			"Name": "Kay County",
			"ShortName": "Kay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40073",
			"Name": "Kingfisher County",
			"ShortName": "Kingfisher",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40075",
			"Name": "Kiowa County",
			"ShortName": "Kiowa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40077",
			"Name": "Latimer County",
			"ShortName": "Latimer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40079",
			"Name": "Le Flore County",
			"ShortName": "Le Flore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40081",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40083",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40085",
			"Name": "Love County",
			"ShortName": "Love",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40093",
			"Name": "Major County",
			"ShortName": "Major",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40095",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40097",
			"Name": "Mayes County",
			"ShortName": "Mayes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40087",
			"Name": "McClain County",
			"ShortName": "McClain",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40089",
			"Name": "McCurtain County",
			"ShortName": "McCurtain",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40091",
			"Name": "McIntosh County",
			"ShortName": "McIntosh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40099",
			"Name": "Murray County",
			"ShortName": "Murray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40101",
			"Name": "Muskogee County",
			"ShortName": "Muskogee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40103",
			"Name": "Noble County",
			"ShortName": "Noble",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40105",
			"Name": "Nowata County",
			"ShortName": "Nowata",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40107",
			"Name": "Okfuskee County",
			"ShortName": "Okfuskee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40109",
			"Name": "Oklahoma County",
			"ShortName": "Oklahoma",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40111",
			"Name": "Okmulgee County",
			"ShortName": "Okmulgee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40113",
			"Name": "Osage County",
			"ShortName": "Osage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40115",
			"Name": "Ottawa County",
			"ShortName": "Ottawa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40117",
			"Name": "Pawnee County",
			"ShortName": "Pawnee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40119",
			"Name": "Payne County",
			"ShortName": "Payne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40121",
			"Name": "Pittsburg County",
			"ShortName": "Pittsburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40123",
			"Name": "Pontotoc County",
			"ShortName": "Pontotoc",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40125",
			"Name": "Pottawatomie County",
			"ShortName": "Pottawatomie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40127",
			"Name": "Pushmataha County",
			"ShortName": "Pushmataha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40129",
			"Name": "Roger Mills County",
			"ShortName": "Roger Mills",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40131",
			"Name": "Rogers County",
			"ShortName": "Rogers",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40133",
			"Name": "Seminole County",
			"ShortName": "Seminole",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40135",
			"Name": "Sequoyah County",
			"ShortName": "Sequoyah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40137",
			"Name": "Stephens County",
			"ShortName": "Stephens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40139",
			"Name": "Texas County",
			"ShortName": "Texas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40141",
			"Name": "Tillman County",
			"ShortName": "Tillman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40143",
			"Name": "Tulsa County",
			"ShortName": "Tulsa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40145",
			"Name": "Wagoner County",
			"ShortName": "Wagoner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40147",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40149",
			"Name": "Washita County",
			"ShortName": "Washita",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40151",
			"Name": "Woods County",
			"ShortName": "Woods",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "40153",
			"Name": "Woodward County",
			"ShortName": "Woodward",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "41",
		"StateName": "Oregon",
		"Counties": [{
			"GeoId": "41001",
			"Name": "Baker County",
			"ShortName": "Baker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41003",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41005",
			"Name": "Clackamas County",
			"ShortName": "Clackamas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41007",
			"Name": "Clatsop County",
			"ShortName": "Clatsop County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41009",
			"Name": "Columbia County",
			"ShortName": "Columbia County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41011",
			"Name": "Coos County",
			"ShortName": "Coos County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41013",
			"Name": "Crook County",
			"ShortName": "Crook",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41015",
			"Name": "Curry County",
			"ShortName": "Curry County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41017",
			"Name": "Deschutes County",
			"ShortName": "Deschutes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41019",
			"Name": "Douglas County",
			"ShortName": "Douglas County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41021",
			"Name": "Gilliam County",
			"ShortName": "Gilliam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41023",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41025",
			"Name": "Harney County",
			"ShortName": "Harney",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41027",
			"Name": "Hood River County",
			"ShortName": "Hood River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41029",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41031",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41033",
			"Name": "Josephine County",
			"ShortName": "Josephine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41035",
			"Name": "Klamath County",
			"ShortName": "Klamath",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41037",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41039",
			"Name": "Lane County",
			"ShortName": "Lane County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41041",
			"Name": "Lincoln County",
			"ShortName": "Lincoln County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41043",
			"Name": "Linn County",
			"ShortName": "Linn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41045",
			"Name": "Malheur County",
			"ShortName": "Malheur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41047",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41049",
			"Name": "Morrow County",
			"ShortName": "Morrow",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41051",
			"Name": "Multnomah County",
			"ShortName": "Multnomah County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41053",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41055",
			"Name": "Sherman County",
			"ShortName": "Sherman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41057",
			"Name": "Tillamook County",
			"ShortName": "Tillamook County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41059",
			"Name": "Umatilla County",
			"ShortName": "Umatilla",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41061",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41063",
			"Name": "Wallowa County",
			"ShortName": "Wallowa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41065",
			"Name": "Wasco County",
			"ShortName": "Wasco",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41067",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41069",
			"Name": "Wheeler County",
			"ShortName": "Wheeler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "41071",
			"Name": "Yamhill County",
			"ShortName": "Yamhill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "42",
		"StateName": "Pennsylvania",
		"Counties": [{
			"GeoId": "42001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42003",
			"Name": "Allegheny County",
			"ShortName": "Allegheny",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42005",
			"Name": "Armstrong County",
			"ShortName": "Armstrong",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42007",
			"Name": "Beaver County",
			"ShortName": "Beaver",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42009",
			"Name": "Bedford County",
			"ShortName": "Bedford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42011",
			"Name": "Berks County",
			"ShortName": "Berks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42013",
			"Name": "Blair County",
			"ShortName": "Blair",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42015",
			"Name": "Bradford County",
			"ShortName": "Bradford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42017",
			"Name": "Bucks County",
			"ShortName": "Bucks County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42019",
			"Name": "Butler County",
			"ShortName": "Butler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42021",
			"Name": "Cambria County",
			"ShortName": "Cambria",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42023",
			"Name": "Cameron County",
			"ShortName": "Cameron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42025",
			"Name": "Carbon County",
			"ShortName": "Carbon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42027",
			"Name": "Centre County",
			"ShortName": "Centre",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42029",
			"Name": "Chester County",
			"ShortName": "Chester",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42031",
			"Name": "Clarion County",
			"ShortName": "Clarion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42033",
			"Name": "Clearfield County",
			"ShortName": "Clearfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42035",
			"Name": "Clinton County",
			"ShortName": "Clinton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42037",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42039",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42041",
			"Name": "Cumberland County",
			"ShortName": "Cumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42043",
			"Name": "Dauphin County",
			"ShortName": "Dauphin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42045",
			"Name": "Delaware County",
			"ShortName": "Delaware County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42047",
			"Name": "Elk County",
			"ShortName": "Elk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42049",
			"Name": "Erie County",
			"ShortName": "Erie County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42051",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42053",
			"Name": "Forest County",
			"ShortName": "Forest",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42055",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42057",
			"Name": "Fulton County",
			"ShortName": "Fulton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42059",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42061",
			"Name": "Huntingdon County",
			"ShortName": "Huntingdon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42063",
			"Name": "Indiana County",
			"ShortName": "Indiana",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42065",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42067",
			"Name": "Juniata County",
			"ShortName": "Juniata",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42069",
			"Name": "Lackawanna County",
			"ShortName": "Lackawanna",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42071",
			"Name": "Lancaster County",
			"ShortName": "Lancaster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42073",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42075",
			"Name": "Lebanon County",
			"ShortName": "Lebanon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42077",
			"Name": "Lehigh County",
			"ShortName": "Lehigh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42079",
			"Name": "Luzerne County",
			"ShortName": "Luzerne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42081",
			"Name": "Lycoming County",
			"ShortName": "Lycoming",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42083",
			"Name": "McKean County",
			"ShortName": "McKean",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42085",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42087",
			"Name": "Mifflin County",
			"ShortName": "Mifflin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42089",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42091",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42093",
			"Name": "Montour County",
			"ShortName": "Montour",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42095",
			"Name": "Northampton County",
			"ShortName": "Northampton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42097",
			"Name": "Northumberland County",
			"ShortName": "Northumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42099",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42101",
			"Name": "Philadelphia County",
			"ShortName": "Philadelphia County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42103",
			"Name": "Pike County",
			"ShortName": "Pike",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42105",
			"Name": "Potter County",
			"ShortName": "Potter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42107",
			"Name": "Schuylkill County",
			"ShortName": "Schuylkill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42109",
			"Name": "Snyder County",
			"ShortName": "Snyder",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42111",
			"Name": "Somerset County",
			"ShortName": "Somerset",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42113",
			"Name": "Sullivan County",
			"ShortName": "Sullivan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42115",
			"Name": "Susquehanna County",
			"ShortName": "Susquehanna",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42117",
			"Name": "Tioga County",
			"ShortName": "Tioga",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42119",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42121",
			"Name": "Venango County",
			"ShortName": "Venango",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42123",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42125",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42127",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42129",
			"Name": "Westmoreland County",
			"ShortName": "Westmoreland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42131",
			"Name": "Wyoming County",
			"ShortName": "Wyoming",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "42133",
			"Name": "York County",
			"ShortName": "York",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "44",
		"StateName": "Rhode Island",
		"Counties": [{
			"GeoId": "44001",
			"Name": "Bristol County",
			"ShortName": "Bristol County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "44003",
			"Name": "Kent County",
			"ShortName": "Kent County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "44005",
			"Name": "Newport County",
			"ShortName": "Newport County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "44007",
			"Name": "Providence County",
			"ShortName": "Providence County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "44009",
			"Name": "Washington County",
			"ShortName": "Washington County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "45",
		"StateName": "South Carolina",
		"Counties": [{
			"GeoId": "45001",
			"Name": "Abbeville County",
			"ShortName": "Abbeville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45003",
			"Name": "Aiken County",
			"ShortName": "Aiken",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45005",
			"Name": "Allendale County",
			"ShortName": "Allendale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45007",
			"Name": "Anderson County",
			"ShortName": "Anderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45009",
			"Name": "Bamberg County",
			"ShortName": "Bamberg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45011",
			"Name": "Barnwell County",
			"ShortName": "Barnwell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45013",
			"Name": "Beaufort County",
			"ShortName": "Beaufort County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45015",
			"Name": "Berkeley County",
			"ShortName": "Berkeley County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45017",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45019",
			"Name": "Charleston County",
			"ShortName": "Charleston County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45021",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45023",
			"Name": "Chester County",
			"ShortName": "Chester",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45025",
			"Name": "Chesterfield County",
			"ShortName": "Chesterfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45027",
			"Name": "Clarendon County",
			"ShortName": "Clarendon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45029",
			"Name": "Colleton County",
			"ShortName": "Colleton County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45031",
			"Name": "Darlington County",
			"ShortName": "Darlington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45033",
			"Name": "Dillon County",
			"ShortName": "Dillon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45035",
			"Name": "Dorchester County",
			"ShortName": "Dorchester County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45037",
			"Name": "Edgefield County",
			"ShortName": "Edgefield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45039",
			"Name": "Fairfield County",
			"ShortName": "Fairfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45041",
			"Name": "Florence County",
			"ShortName": "Florence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45043",
			"Name": "Georgetown County",
			"ShortName": "Georgetown County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45045",
			"Name": "Greenville County",
			"ShortName": "Greenville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45047",
			"Name": "Greenwood County",
			"ShortName": "Greenwood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45049",
			"Name": "Hampton County",
			"ShortName": "Hampton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45051",
			"Name": "Horry County",
			"ShortName": "Horry County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45053",
			"Name": "Jasper County",
			"ShortName": "Jasper County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45055",
			"Name": "Kershaw County",
			"ShortName": "Kershaw",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45057",
			"Name": "Lancaster County",
			"ShortName": "Lancaster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45059",
			"Name": "Laurens County",
			"ShortName": "Laurens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45061",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45063",
			"Name": "Lexington County",
			"ShortName": "Lexington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45067",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45069",
			"Name": "Marlboro County",
			"ShortName": "Marlboro",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45065",
			"Name": "McCormick County",
			"ShortName": "McCormick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45071",
			"Name": "Newberry County",
			"ShortName": "Newberry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45073",
			"Name": "Oconee County",
			"ShortName": "Oconee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45075",
			"Name": "Orangeburg County",
			"ShortName": "Orangeburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45077",
			"Name": "Pickens County",
			"ShortName": "Pickens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45079",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45081",
			"Name": "Saluda County",
			"ShortName": "Saluda",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45083",
			"Name": "Spartanburg County",
			"ShortName": "Spartanburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45085",
			"Name": "Sumter County",
			"ShortName": "Sumter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45087",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45089",
			"Name": "Williamsburg County",
			"ShortName": "Williamsburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "45091",
			"Name": "York County",
			"ShortName": "York",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "46",
		"StateName": "South Dakota",
		"Counties": [{
			"GeoId": "46003",
			"Name": "Aurora County",
			"ShortName": "Aurora",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46005",
			"Name": "Beadle County",
			"ShortName": "Beadle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46007",
			"Name": "Bennett County",
			"ShortName": "Bennett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46009",
			"Name": "Bon Homme County",
			"ShortName": "Bon Homme",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46011",
			"Name": "Brookings County",
			"ShortName": "Brookings",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46013",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46015",
			"Name": "Brule County",
			"ShortName": "Brule",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46017",
			"Name": "Buffalo County",
			"ShortName": "Buffalo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46019",
			"Name": "Butte County",
			"ShortName": "Butte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46021",
			"Name": "Campbell County",
			"ShortName": "Campbell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46023",
			"Name": "Charles Mix County",
			"ShortName": "Charles Mix",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46025",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46027",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46029",
			"Name": "Codington County",
			"ShortName": "Codington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46031",
			"Name": "Corson County",
			"ShortName": "Corson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46033",
			"Name": "Custer County",
			"ShortName": "Custer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46035",
			"Name": "Davison County",
			"ShortName": "Davison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46037",
			"Name": "Day County",
			"ShortName": "Day",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46039",
			"Name": "Deuel County",
			"ShortName": "Deuel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46041",
			"Name": "Dewey County",
			"ShortName": "Dewey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46043",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46045",
			"Name": "Edmunds County",
			"ShortName": "Edmunds",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46047",
			"Name": "Fall River County",
			"ShortName": "Fall River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46049",
			"Name": "Faulk County",
			"ShortName": "Faulk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46051",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46053",
			"Name": "Gregory County",
			"ShortName": "Gregory",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46055",
			"Name": "Haakon County",
			"ShortName": "Haakon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46057",
			"Name": "Hamlin County",
			"ShortName": "Hamlin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46059",
			"Name": "Hand County",
			"ShortName": "Hand",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46061",
			"Name": "Hanson County",
			"ShortName": "Hanson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46063",
			"Name": "Harding County",
			"ShortName": "Harding",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46065",
			"Name": "Hughes County",
			"ShortName": "Hughes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46067",
			"Name": "Hutchinson County",
			"ShortName": "Hutchinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46069",
			"Name": "Hyde County",
			"ShortName": "Hyde",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46071",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46073",
			"Name": "Jerauld County",
			"ShortName": "Jerauld",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46075",
			"Name": "Jones County",
			"ShortName": "Jones",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46077",
			"Name": "Kingsbury County",
			"ShortName": "Kingsbury",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46079",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46081",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46083",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46085",
			"Name": "Lyman County",
			"ShortName": "Lyman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46091",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46087",
			"Name": "McCook County",
			"ShortName": "McCook",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46089",
			"Name": "McPherson County",
			"ShortName": "McPherson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46093",
			"Name": "Meade County",
			"ShortName": "Meade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46095",
			"Name": "Mellette County",
			"ShortName": "Mellette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46097",
			"Name": "Miner County",
			"ShortName": "Miner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46099",
			"Name": "Minnehaha County",
			"ShortName": "Minnehaha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46101",
			"Name": "Moody County",
			"ShortName": "Moody",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46103",
			"Name": "Pennington County",
			"ShortName": "Pennington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46105",
			"Name": "Perkins County",
			"ShortName": "Perkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46107",
			"Name": "Potter County",
			"ShortName": "Potter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46109",
			"Name": "Roberts County",
			"ShortName": "Roberts",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46111",
			"Name": "Sanborn County",
			"ShortName": "Sanborn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46115",
			"Name": "Spink County",
			"ShortName": "Spink",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46117",
			"Name": "Stanley County",
			"ShortName": "Stanley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46119",
			"Name": "Sully County",
			"ShortName": "Sully",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46121",
			"Name": "Todd County",
			"ShortName": "Todd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46123",
			"Name": "Tripp County",
			"ShortName": "Tripp",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46125",
			"Name": "Turner County",
			"ShortName": "Turner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46127",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46129",
			"Name": "Walworth County",
			"ShortName": "Walworth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46135",
			"Name": "Yankton County",
			"ShortName": "Yankton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "46137",
			"Name": "Ziebach County",
			"ShortName": "Ziebach",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "47",
		"StateName": "Tennessee",
		"Counties": [{
			"GeoId": "47001",
			"Name": "Anderson County",
			"ShortName": "Anderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47003",
			"Name": "Bedford County",
			"ShortName": "Bedford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47005",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47007",
			"Name": "Bledsoe County",
			"ShortName": "Bledsoe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47009",
			"Name": "Blount County",
			"ShortName": "Blount",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47011",
			"Name": "Bradley County",
			"ShortName": "Bradley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47013",
			"Name": "Campbell County",
			"ShortName": "Campbell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47015",
			"Name": "Cannon County",
			"ShortName": "Cannon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47017",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47019",
			"Name": "Carter County",
			"ShortName": "Carter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47021",
			"Name": "Cheatham County",
			"ShortName": "Cheatham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47023",
			"Name": "Chester County",
			"ShortName": "Chester",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47025",
			"Name": "Claiborne County",
			"ShortName": "Claiborne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47027",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47029",
			"Name": "Cocke County",
			"ShortName": "Cocke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47031",
			"Name": "Coffee County",
			"ShortName": "Coffee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47033",
			"Name": "Crockett County",
			"ShortName": "Crockett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47035",
			"Name": "Cumberland County",
			"ShortName": "Cumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47037",
			"Name": "Davidson County",
			"ShortName": "Davidson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47039",
			"Name": "Decatur County",
			"ShortName": "Decatur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47041",
			"Name": "DeKalb County",
			"ShortName": "DeKalb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47043",
			"Name": "Dickson County",
			"ShortName": "Dickson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47045",
			"Name": "Dyer County",
			"ShortName": "Dyer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47047",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47049",
			"Name": "Fentress County",
			"ShortName": "Fentress",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47051",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47053",
			"Name": "Gibson County",
			"ShortName": "Gibson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47055",
			"Name": "Giles County",
			"ShortName": "Giles",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47057",
			"Name": "Grainger County",
			"ShortName": "Grainger",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47059",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47061",
			"Name": "Grundy County",
			"ShortName": "Grundy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47063",
			"Name": "Hamblen County",
			"ShortName": "Hamblen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47065",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47067",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47069",
			"Name": "Hardeman County",
			"ShortName": "Hardeman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47071",
			"Name": "Hardin County",
			"ShortName": "Hardin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47073",
			"Name": "Hawkins County",
			"ShortName": "Hawkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47075",
			"Name": "Haywood County",
			"ShortName": "Haywood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47077",
			"Name": "Henderson County",
			"ShortName": "Henderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47079",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47081",
			"Name": "Hickman County",
			"ShortName": "Hickman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47083",
			"Name": "Houston County",
			"ShortName": "Houston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47085",
			"Name": "Humphreys County",
			"ShortName": "Humphreys",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47087",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47089",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47091",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47093",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47095",
			"Name": "Lake County",
			"ShortName": "Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47097",
			"Name": "Lauderdale County",
			"ShortName": "Lauderdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47099",
			"Name": "Lawrence County",
			"ShortName": "Lawrence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47101",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47103",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47105",
			"Name": "Loudon County",
			"ShortName": "Loudon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47111",
			"Name": "Macon County",
			"ShortName": "Macon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47113",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47115",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47117",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47119",
			"Name": "Maury County",
			"ShortName": "Maury",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47107",
			"Name": "McMinn County",
			"ShortName": "McMinn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47109",
			"Name": "McNairy County",
			"ShortName": "McNairy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47121",
			"Name": "Meigs County",
			"ShortName": "Meigs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47123",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47125",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47127",
			"Name": "Moore County",
			"ShortName": "Moore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47129",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47131",
			"Name": "Obion County",
			"ShortName": "Obion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47133",
			"Name": "Overton County",
			"ShortName": "Overton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47135",
			"Name": "Perry County",
			"ShortName": "Perry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47137",
			"Name": "Pickett County",
			"ShortName": "Pickett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47139",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47141",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47143",
			"Name": "Rhea County",
			"ShortName": "Rhea",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47145",
			"Name": "Roane County",
			"ShortName": "Roane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47147",
			"Name": "Robertson County",
			"ShortName": "Robertson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47149",
			"Name": "Rutherford County",
			"ShortName": "Rutherford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47151",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47153",
			"Name": "Sequatchie County",
			"ShortName": "Sequatchie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47155",
			"Name": "Sevier County",
			"ShortName": "Sevier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47157",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47159",
			"Name": "Smith County",
			"ShortName": "Smith",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47161",
			"Name": "Stewart County",
			"ShortName": "Stewart",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47163",
			"Name": "Sullivan County",
			"ShortName": "Sullivan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47165",
			"Name": "Sumner County",
			"ShortName": "Sumner",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47167",
			"Name": "Tipton County",
			"ShortName": "Tipton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47169",
			"Name": "Trousdale County",
			"ShortName": "Trousdale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47171",
			"Name": "Unicoi County",
			"ShortName": "Unicoi",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47173",
			"Name": "Union County",
			"ShortName": "Union",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47175",
			"Name": "Van Buren County",
			"ShortName": "Van Buren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47177",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47179",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47181",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47183",
			"Name": "Weakley County",
			"ShortName": "Weakley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47185",
			"Name": "White County",
			"ShortName": "White",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47187",
			"Name": "Williamson County",
			"ShortName": "Williamson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "47189",
			"Name": "Wilson County",
			"ShortName": "Wilson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "48",
		"StateName": "Texas",
		"Counties": [{
			"GeoId": "48001",
			"Name": "Anderson County",
			"ShortName": "Anderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48003",
			"Name": "Andrews County",
			"ShortName": "Andrews",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48005",
			"Name": "Angelina County",
			"ShortName": "Angelina",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48007",
			"Name": "Aransas County",
			"ShortName": "Aransas County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48009",
			"Name": "Archer County",
			"ShortName": "Archer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48011",
			"Name": "Armstrong County",
			"ShortName": "Armstrong",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48013",
			"Name": "Atascosa County",
			"ShortName": "Atascosa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48015",
			"Name": "Austin County",
			"ShortName": "Austin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48017",
			"Name": "Bailey County",
			"ShortName": "Bailey",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48019",
			"Name": "Bandera County",
			"ShortName": "Bandera",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48021",
			"Name": "Bastrop County",
			"ShortName": "Bastrop",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48023",
			"Name": "Baylor County",
			"ShortName": "Baylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48025",
			"Name": "Bee County",
			"ShortName": "Bee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48027",
			"Name": "Bell County",
			"ShortName": "Bell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48029",
			"Name": "Bexar County",
			"ShortName": "Bexar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48031",
			"Name": "Blanco County",
			"ShortName": "Blanco",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48033",
			"Name": "Borden County",
			"ShortName": "Borden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48035",
			"Name": "Bosque County",
			"ShortName": "Bosque",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48037",
			"Name": "Bowie County",
			"ShortName": "Bowie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48039",
			"Name": "Brazoria County",
			"ShortName": "Brazoria County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48041",
			"Name": "Brazos County",
			"ShortName": "Brazos",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48043",
			"Name": "Brewster County",
			"ShortName": "Brewster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48045",
			"Name": "Briscoe County",
			"ShortName": "Briscoe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48047",
			"Name": "Brooks County",
			"ShortName": "Brooks",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48049",
			"Name": "Brown County",
			"ShortName": "Brown",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48051",
			"Name": "Burleson County",
			"ShortName": "Burleson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48053",
			"Name": "Burnet County",
			"ShortName": "Burnet",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48055",
			"Name": "Caldwell County",
			"ShortName": "Caldwell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48057",
			"Name": "Calhoun County",
			"ShortName": "Calhoun County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48059",
			"Name": "Callahan County",
			"ShortName": "Callahan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48061",
			"Name": "Cameron County",
			"ShortName": "Cameron County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48063",
			"Name": "Camp County",
			"ShortName": "Camp",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48065",
			"Name": "Carson County",
			"ShortName": "Carson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48067",
			"Name": "Cass County",
			"ShortName": "Cass",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48069",
			"Name": "Castro County",
			"ShortName": "Castro",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48071",
			"Name": "Chambers County",
			"ShortName": "Chambers County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48073",
			"Name": "Cherokee County",
			"ShortName": "Cherokee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48075",
			"Name": "Childress County",
			"ShortName": "Childress",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48077",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48079",
			"Name": "Cochran County",
			"ShortName": "Cochran",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48081",
			"Name": "Coke County",
			"ShortName": "Coke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48083",
			"Name": "Coleman County",
			"ShortName": "Coleman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48085",
			"Name": "Collin County",
			"ShortName": "Collin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48087",
			"Name": "Collingsworth County",
			"ShortName": "Collingsworth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48089",
			"Name": "Colorado County",
			"ShortName": "Colorado",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48091",
			"Name": "Comal County",
			"ShortName": "Comal",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48093",
			"Name": "Comanche County",
			"ShortName": "Comanche",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48095",
			"Name": "Concho County",
			"ShortName": "Concho",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48097",
			"Name": "Cooke County",
			"ShortName": "Cooke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48099",
			"Name": "Coryell County",
			"ShortName": "Coryell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48101",
			"Name": "Cottle County",
			"ShortName": "Cottle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48103",
			"Name": "Crane County",
			"ShortName": "Crane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48105",
			"Name": "Crockett County",
			"ShortName": "Crockett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48107",
			"Name": "Crosby County",
			"ShortName": "Crosby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48109",
			"Name": "Culberson County",
			"ShortName": "Culberson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48111",
			"Name": "Dallam County",
			"ShortName": "Dallam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48113",
			"Name": "Dallas County",
			"ShortName": "Dallas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48115",
			"Name": "Dawson County",
			"ShortName": "Dawson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48117",
			"Name": "Deaf Smith County",
			"ShortName": "Deaf Smith",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48119",
			"Name": "Delta County",
			"ShortName": "Delta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48121",
			"Name": "Denton County",
			"ShortName": "Denton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48123",
			"Name": "DeWitt County",
			"ShortName": "DeWitt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48125",
			"Name": "Dickens County",
			"ShortName": "Dickens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48127",
			"Name": "Dimmit County",
			"ShortName": "Dimmit",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48129",
			"Name": "Donley County",
			"ShortName": "Donley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48131",
			"Name": "Duval County",
			"ShortName": "Duval",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48133",
			"Name": "Eastland County",
			"ShortName": "Eastland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48135",
			"Name": "Ector County",
			"ShortName": "Ector",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48137",
			"Name": "Edwards County",
			"ShortName": "Edwards",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48141",
			"Name": "El Paso County",
			"ShortName": "El Paso",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48139",
			"Name": "Ellis County",
			"ShortName": "Ellis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48143",
			"Name": "Erath County",
			"ShortName": "Erath",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48145",
			"Name": "Falls County",
			"ShortName": "Falls",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48147",
			"Name": "Fannin County",
			"ShortName": "Fannin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48149",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48151",
			"Name": "Fisher County",
			"ShortName": "Fisher",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48153",
			"Name": "Floyd County",
			"ShortName": "Floyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48155",
			"Name": "Foard County",
			"ShortName": "Foard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48157",
			"Name": "Fort Bend County",
			"ShortName": "Fort Bend",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48159",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48161",
			"Name": "Freestone County",
			"ShortName": "Freestone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48163",
			"Name": "Frio County",
			"ShortName": "Frio",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48165",
			"Name": "Gaines County",
			"ShortName": "Gaines",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48167",
			"Name": "Galveston County",
			"ShortName": "Galveston County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48169",
			"Name": "Garza County",
			"ShortName": "Garza",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48171",
			"Name": "Gillespie County",
			"ShortName": "Gillespie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48173",
			"Name": "Glasscock County",
			"ShortName": "Glasscock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48175",
			"Name": "Goliad County",
			"ShortName": "Goliad",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48177",
			"Name": "Gonzales County",
			"ShortName": "Gonzales",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48179",
			"Name": "Gray County",
			"ShortName": "Gray",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48181",
			"Name": "Grayson County",
			"ShortName": "Grayson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48183",
			"Name": "Gregg County",
			"ShortName": "Gregg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48185",
			"Name": "Grimes County",
			"ShortName": "Grimes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48187",
			"Name": "Guadalupe County",
			"ShortName": "Guadalupe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48189",
			"Name": "Hale County",
			"ShortName": "Hale",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48191",
			"Name": "Hall County",
			"ShortName": "Hall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48193",
			"Name": "Hamilton County",
			"ShortName": "Hamilton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48195",
			"Name": "Hansford County",
			"ShortName": "Hansford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48197",
			"Name": "Hardeman County",
			"ShortName": "Hardeman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48199",
			"Name": "Hardin County",
			"ShortName": "Hardin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48201",
			"Name": "Harris County",
			"ShortName": "Harris County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48203",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48205",
			"Name": "Hartley County",
			"ShortName": "Hartley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48207",
			"Name": "Haskell County",
			"ShortName": "Haskell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48209",
			"Name": "Hays County",
			"ShortName": "Hays",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48211",
			"Name": "Hemphill County",
			"ShortName": "Hemphill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48213",
			"Name": "Henderson County",
			"ShortName": "Henderson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48215",
			"Name": "Hidalgo County",
			"ShortName": "Hidalgo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48217",
			"Name": "Hill County",
			"ShortName": "Hill",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48219",
			"Name": "Hockley County",
			"ShortName": "Hockley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48221",
			"Name": "Hood County",
			"ShortName": "Hood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48223",
			"Name": "Hopkins County",
			"ShortName": "Hopkins",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48225",
			"Name": "Houston County",
			"ShortName": "Houston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48227",
			"Name": "Howard County",
			"ShortName": "Howard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48229",
			"Name": "Hudspeth County",
			"ShortName": "Hudspeth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48231",
			"Name": "Hunt County",
			"ShortName": "Hunt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48233",
			"Name": "Hutchinson County",
			"ShortName": "Hutchinson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48235",
			"Name": "Irion County",
			"ShortName": "Irion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48237",
			"Name": "Jack County",
			"ShortName": "Jack",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48239",
			"Name": "Jackson County",
			"ShortName": "Jackson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48241",
			"Name": "Jasper County",
			"ShortName": "Jasper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48243",
			"Name": "Jeff Davis County",
			"ShortName": "Jeff Davis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48245",
			"Name": "Jefferson County",
			"ShortName": "Jefferson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48247",
			"Name": "Jim Hogg County",
			"ShortName": "Jim Hogg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48249",
			"Name": "Jim Wells County",
			"ShortName": "Jim Wells",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48251",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48253",
			"Name": "Jones County",
			"ShortName": "Jones",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48255",
			"Name": "Karnes County",
			"ShortName": "Karnes",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48257",
			"Name": "Kaufman County",
			"ShortName": "Kaufman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48259",
			"Name": "Kendall County",
			"ShortName": "Kendall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48261",
			"Name": "Kenedy County",
			"ShortName": "Kenedy County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48263",
			"Name": "Kent County",
			"ShortName": "Kent",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48265",
			"Name": "Kerr County",
			"ShortName": "Kerr",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48267",
			"Name": "Kimble County",
			"ShortName": "Kimble",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48269",
			"Name": "King County",
			"ShortName": "King",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48271",
			"Name": "Kinney County",
			"ShortName": "Kinney",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48273",
			"Name": "Kleberg County",
			"ShortName": "Kleberg County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48275",
			"Name": "Knox County",
			"ShortName": "Knox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48283",
			"Name": "La Salle County",
			"ShortName": "La Salle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48277",
			"Name": "Lamar County",
			"ShortName": "Lamar",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48279",
			"Name": "Lamb County",
			"ShortName": "Lamb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48281",
			"Name": "Lampasas County",
			"ShortName": "Lampasas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48285",
			"Name": "Lavaca County",
			"ShortName": "Lavaca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48287",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48289",
			"Name": "Leon County",
			"ShortName": "Leon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48291",
			"Name": "Liberty County",
			"ShortName": "Liberty",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48293",
			"Name": "Limestone County",
			"ShortName": "Limestone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48295",
			"Name": "Lipscomb County",
			"ShortName": "Lipscomb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48297",
			"Name": "Live Oak County",
			"ShortName": "Live Oak",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48299",
			"Name": "Llano County",
			"ShortName": "Llano",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48301",
			"Name": "Loving County",
			"ShortName": "Loving",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48303",
			"Name": "Lubbock County",
			"ShortName": "Lubbock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48305",
			"Name": "Lynn County",
			"ShortName": "Lynn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48313",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48315",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48317",
			"Name": "Martin County",
			"ShortName": "Martin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48319",
			"Name": "Mason County",
			"ShortName": "Mason",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48321",
			"Name": "Matagorda County",
			"ShortName": "Matagorda County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48323",
			"Name": "Maverick County",
			"ShortName": "Maverick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48307",
			"Name": "McCulloch County",
			"ShortName": "McCulloch",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48309",
			"Name": "McLennan County",
			"ShortName": "McLennan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48311",
			"Name": "McMullen County",
			"ShortName": "McMullen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48325",
			"Name": "Medina County",
			"ShortName": "Medina",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48327",
			"Name": "Menard County",
			"ShortName": "Menard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48329",
			"Name": "Midland County",
			"ShortName": "Midland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48331",
			"Name": "Milam County",
			"ShortName": "Milam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48333",
			"Name": "Mills County",
			"ShortName": "Mills",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48335",
			"Name": "Mitchell County",
			"ShortName": "Mitchell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48337",
			"Name": "Montague County",
			"ShortName": "Montague",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48339",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48341",
			"Name": "Moore County",
			"ShortName": "Moore",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48343",
			"Name": "Morris County",
			"ShortName": "Morris",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48345",
			"Name": "Motley County",
			"ShortName": "Motley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48347",
			"Name": "Nacogdoches County",
			"ShortName": "Nacogdoches",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48349",
			"Name": "Navarro County",
			"ShortName": "Navarro",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48351",
			"Name": "Newton County",
			"ShortName": "Newton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48353",
			"Name": "Nolan County",
			"ShortName": "Nolan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48355",
			"Name": "Nueces County",
			"ShortName": "Nueces County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48357",
			"Name": "Ochiltree County",
			"ShortName": "Ochiltree",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48359",
			"Name": "Oldham County",
			"ShortName": "Oldham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48361",
			"Name": "Orange County",
			"ShortName": "Orange County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48363",
			"Name": "Palo Pinto County",
			"ShortName": "Palo Pinto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48365",
			"Name": "Panola County",
			"ShortName": "Panola",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48367",
			"Name": "Parker County",
			"ShortName": "Parker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48369",
			"Name": "Parmer County",
			"ShortName": "Parmer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48371",
			"Name": "Pecos County",
			"ShortName": "Pecos",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48373",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48375",
			"Name": "Potter County",
			"ShortName": "Potter",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48377",
			"Name": "Presidio County",
			"ShortName": "Presidio",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48379",
			"Name": "Rains County",
			"ShortName": "Rains",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48381",
			"Name": "Randall County",
			"ShortName": "Randall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48383",
			"Name": "Reagan County",
			"ShortName": "Reagan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48385",
			"Name": "Real County",
			"ShortName": "Real",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48387",
			"Name": "Red River County",
			"ShortName": "Red River",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48389",
			"Name": "Reeves County",
			"ShortName": "Reeves",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48391",
			"Name": "Refugio County",
			"ShortName": "Refugio County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48393",
			"Name": "Roberts County",
			"ShortName": "Roberts",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48395",
			"Name": "Robertson County",
			"ShortName": "Robertson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48397",
			"Name": "Rockwall County",
			"ShortName": "Rockwall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48399",
			"Name": "Runnels County",
			"ShortName": "Runnels",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48401",
			"Name": "Rusk County",
			"ShortName": "Rusk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48403",
			"Name": "Sabine County",
			"ShortName": "Sabine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48405",
			"Name": "San Augustine County",
			"ShortName": "San Augustine",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48407",
			"Name": "San Jacinto County",
			"ShortName": "San Jacinto",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48409",
			"Name": "San Patricio County",
			"ShortName": "San Patricio County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48411",
			"Name": "San Saba County",
			"ShortName": "San Saba",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48413",
			"Name": "Schleicher County",
			"ShortName": "Schleicher",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48415",
			"Name": "Scurry County",
			"ShortName": "Scurry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48417",
			"Name": "Shackelford County",
			"ShortName": "Shackelford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48419",
			"Name": "Shelby County",
			"ShortName": "Shelby",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48421",
			"Name": "Sherman County",
			"ShortName": "Sherman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48423",
			"Name": "Smith County",
			"ShortName": "Smith",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48425",
			"Name": "Somervell County",
			"ShortName": "Somervell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48427",
			"Name": "Starr County",
			"ShortName": "Starr",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48429",
			"Name": "Stephens County",
			"ShortName": "Stephens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48431",
			"Name": "Sterling County",
			"ShortName": "Sterling",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48433",
			"Name": "Stonewall County",
			"ShortName": "Stonewall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48435",
			"Name": "Sutton County",
			"ShortName": "Sutton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48437",
			"Name": "Swisher County",
			"ShortName": "Swisher",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48439",
			"Name": "Tarrant County",
			"ShortName": "Tarrant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48441",
			"Name": "Taylor County",
			"ShortName": "Taylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48443",
			"Name": "Terrell County",
			"ShortName": "Terrell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48445",
			"Name": "Terry County",
			"ShortName": "Terry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48447",
			"Name": "Throckmorton County",
			"ShortName": "Throckmorton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48449",
			"Name": "Titus County",
			"ShortName": "Titus",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48451",
			"Name": "Tom Green County",
			"ShortName": "Tom Green",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48453",
			"Name": "Travis County",
			"ShortName": "Travis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48455",
			"Name": "Trinity County",
			"ShortName": "Trinity",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48457",
			"Name": "Tyler County",
			"ShortName": "Tyler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48459",
			"Name": "Upshur County",
			"ShortName": "Upshur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48461",
			"Name": "Upton County",
			"ShortName": "Upton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48463",
			"Name": "Uvalde County",
			"ShortName": "Uvalde",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48465",
			"Name": "Val Verde County",
			"ShortName": "Val Verde",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48467",
			"Name": "Van Zandt County",
			"ShortName": "Van Zandt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48469",
			"Name": "Victoria County",
			"ShortName": "Victoria County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48471",
			"Name": "Walker County",
			"ShortName": "Walker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48473",
			"Name": "Waller County",
			"ShortName": "Waller",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48475",
			"Name": "Ward County",
			"ShortName": "Ward",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48477",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48479",
			"Name": "Webb County",
			"ShortName": "Webb",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48481",
			"Name": "Wharton County",
			"ShortName": "Wharton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48483",
			"Name": "Wheeler County",
			"ShortName": "Wheeler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48485",
			"Name": "Wichita County",
			"ShortName": "Wichita",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48487",
			"Name": "Wilbarger County",
			"ShortName": "Wilbarger",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48489",
			"Name": "Willacy County",
			"ShortName": "Willacy County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48491",
			"Name": "Williamson County",
			"ShortName": "Williamson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48493",
			"Name": "Wilson County",
			"ShortName": "Wilson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48495",
			"Name": "Winkler County",
			"ShortName": "Winkler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48497",
			"Name": "Wise County",
			"ShortName": "Wise",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48499",
			"Name": "Wood County",
			"ShortName": "Wood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48501",
			"Name": "Yoakum County",
			"ShortName": "Yoakum",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48503",
			"Name": "Young County",
			"ShortName": "Young",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48505",
			"Name": "Zapata County",
			"ShortName": "Zapata",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "48507",
			"Name": "Zavala County",
			"ShortName": "Zavala",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "49",
		"StateName": "Utah",
		"Counties": [{
			"GeoId": "49001",
			"Name": "Beaver County",
			"ShortName": "Beaver",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49003",
			"Name": "Box Elder County",
			"ShortName": "Box Elder",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49005",
			"Name": "Cache County",
			"ShortName": "Cache",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49007",
			"Name": "Carbon County",
			"ShortName": "Carbon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49009",
			"Name": "Daggett County",
			"ShortName": "Daggett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49011",
			"Name": "Davis County",
			"ShortName": "Davis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49013",
			"Name": "Duchesne County",
			"ShortName": "Duchesne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49015",
			"Name": "Emery County",
			"ShortName": "Emery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49017",
			"Name": "Garfield County",
			"ShortName": "Garfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49019",
			"Name": "Grand County",
			"ShortName": "Grand",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49021",
			"Name": "Iron County",
			"ShortName": "Iron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49023",
			"Name": "Juab County",
			"ShortName": "Juab",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49025",
			"Name": "Kane County",
			"ShortName": "Kane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49027",
			"Name": "Millard County",
			"ShortName": "Millard",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49029",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49031",
			"Name": "Piute County",
			"ShortName": "Piute",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49033",
			"Name": "Rich County",
			"ShortName": "Rich",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49035",
			"Name": "Salt Lake County",
			"ShortName": "Salt Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49037",
			"Name": "San Juan County",
			"ShortName": "San Juan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49039",
			"Name": "Sanpete County",
			"ShortName": "Sanpete",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49041",
			"Name": "Sevier County",
			"ShortName": "Sevier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49043",
			"Name": "Summit County",
			"ShortName": "Summit",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49045",
			"Name": "Tooele County",
			"ShortName": "Tooele",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49047",
			"Name": "Uintah County",
			"ShortName": "Uintah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49049",
			"Name": "Utah County",
			"ShortName": "Utah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49051",
			"Name": "Wasatch County",
			"ShortName": "Wasatch",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49053",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49055",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "49057",
			"Name": "Weber County",
			"ShortName": "Weber",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "50",
		"StateName": "Vermont",
		"Counties": [{
			"GeoId": "50001",
			"Name": "Addison County",
			"ShortName": "Addison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50003",
			"Name": "Bennington County",
			"ShortName": "Bennington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50005",
			"Name": "Caledonia County",
			"ShortName": "Caledonia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50007",
			"Name": "Chittenden County",
			"ShortName": "Chittenden",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50009",
			"Name": "Essex County",
			"ShortName": "Essex",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50011",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50013",
			"Name": "Grand Isle County",
			"ShortName": "Grand Isle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50015",
			"Name": "Lamoille County",
			"ShortName": "Lamoille",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50017",
			"Name": "Orange County",
			"ShortName": "Orange",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50019",
			"Name": "Orleans County",
			"ShortName": "Orleans",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50021",
			"Name": "Rutland County",
			"ShortName": "Rutland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50023",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50025",
			"Name": "Windham County",
			"ShortName": "Windham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "50027",
			"Name": "Windsor County",
			"ShortName": "Windsor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "51",
		"StateName": "Virginia",
		"Counties": [{
			"GeoId": "51001",
			"Name": "Accomack County",
			"ShortName": "Accomack County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51003",
			"Name": "Albemarle County",
			"ShortName": "Albemarle",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51510",
			"Name": "Alexandria City County",
			"ShortName": "Alexandria City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51005",
			"Name": "Alleghany County",
			"ShortName": "Alleghany",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51007",
			"Name": "Amelia County",
			"ShortName": "Amelia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51009",
			"Name": "Amherst County",
			"ShortName": "Amherst",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51011",
			"Name": "Appomattox County",
			"ShortName": "Appomattox",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51013",
			"Name": "Arlington County",
			"ShortName": "Arlington County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51015",
			"Name": "Augusta County",
			"ShortName": "Augusta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51017",
			"Name": "Bath County",
			"ShortName": "Bath",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51019",
			"Name": "Bedford County",
			"ShortName": "Bedford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51021",
			"Name": "Bland County",
			"ShortName": "Bland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51023",
			"Name": "Botetourt County",
			"ShortName": "Botetourt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51520",
			"Name": "Bristol County",
			"ShortName": "Bristol",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51025",
			"Name": "Brunswick County",
			"ShortName": "Brunswick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51027",
			"Name": "Buchanan County",
			"ShortName": "Buchanan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51029",
			"Name": "Buckingham County",
			"ShortName": "Buckingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51530",
			"Name": "Buena Vista County",
			"ShortName": "Buena Vista",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51031",
			"Name": "Campbell County",
			"ShortName": "Campbell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51033",
			"Name": "Caroline County",
			"ShortName": "Caroline County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51035",
			"Name": "Carroll County",
			"ShortName": "Carroll",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51036",
			"Name": "Charles City County",
			"ShortName": "Charles City County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51037",
			"Name": "Charlotte County",
			"ShortName": "Charlotte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51540",
			"Name": "Charlottesville County",
			"ShortName": "Charlottesville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51550",
			"Name": "Chesapeake City County",
			"ShortName": "Chesapeake City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51041",
			"Name": "Chesterfield County",
			"ShortName": "Chesterfield County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51043",
			"Name": "Clarke County",
			"ShortName": "Clarke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51570",
			"Name": "Colonial Heights County",
			"ShortName": "Colonial Heights",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51580",
			"Name": "Covington County",
			"ShortName": "Covington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51045",
			"Name": "Craig County",
			"ShortName": "Craig",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51047",
			"Name": "Culpeper County",
			"ShortName": "Culpeper",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51049",
			"Name": "Cumberland County",
			"ShortName": "Cumberland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51590",
			"Name": "Danville County",
			"ShortName": "Danville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51051",
			"Name": "Dickenson County",
			"ShortName": "Dickenson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51053",
			"Name": "Dinwiddie County",
			"ShortName": "Dinwiddie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51595",
			"Name": "Emporia County",
			"ShortName": "Emporia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51057",
			"Name": "Essex County",
			"ShortName": "Essex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51600",
			"Name": "Fairfax County",
			"ShortName": "Fairfax",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51059",
			"Name": "Fairfax County",
			"ShortName": "Fairfax County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51610",
			"Name": "Falls Church County",
			"ShortName": "Falls Church",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51061",
			"Name": "Fauquier County",
			"ShortName": "Fauquier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51063",
			"Name": "Floyd County",
			"ShortName": "Floyd",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51065",
			"Name": "Fluvanna County",
			"ShortName": "Fluvanna",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51067",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51620",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51069",
			"Name": "Frederick County",
			"ShortName": "Frederick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51630",
			"Name": "Fredericksburg County",
			"ShortName": "Fredericksburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51640",
			"Name": "Galax County",
			"ShortName": "Galax",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51071",
			"Name": "Giles County",
			"ShortName": "Giles",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51073",
			"Name": "Gloucester County",
			"ShortName": "Gloucester County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51075",
			"Name": "Goochland County",
			"ShortName": "Goochland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51077",
			"Name": "Grayson County",
			"ShortName": "Grayson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51079",
			"Name": "Greene County",
			"ShortName": "Greene",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51081",
			"Name": "Greensville County",
			"ShortName": "Greensville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51083",
			"Name": "Halifax County",
			"ShortName": "Halifax",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51650",
			"Name": "Hampton City County",
			"ShortName": "Hampton City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51085",
			"Name": "Hanover County",
			"ShortName": "Hanover County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51660",
			"Name": "Harrisonburg County",
			"ShortName": "Harrisonburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51087",
			"Name": "Henrico County",
			"ShortName": "Henrico County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51089",
			"Name": "Henry County",
			"ShortName": "Henry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51091",
			"Name": "Highland County",
			"ShortName": "Highland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51670",
			"Name": "Hopewell City County",
			"ShortName": "Hopewell City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51093",
			"Name": "Isle of Wight County",
			"ShortName": "Isle of Wight County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51095",
			"Name": "James City County",
			"ShortName": "James City County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51097",
			"Name": "King and Queen County",
			"ShortName": "King and Queen County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51099",
			"Name": "King George County",
			"ShortName": "King George County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51101",
			"Name": "King William County",
			"ShortName": "King William County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51103",
			"Name": "Lancaster County",
			"ShortName": "Lancaster County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51105",
			"Name": "Lee County",
			"ShortName": "Lee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51678",
			"Name": "Lexington County",
			"ShortName": "Lexington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51107",
			"Name": "Loudoun County",
			"ShortName": "Loudoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51109",
			"Name": "Louisa County",
			"ShortName": "Louisa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51111",
			"Name": "Lunenburg County",
			"ShortName": "Lunenburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51680",
			"Name": "Lynchburg County",
			"ShortName": "Lynchburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51113",
			"Name": "Madison County",
			"ShortName": "Madison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51683",
			"Name": "Manassas County",
			"ShortName": "Manassas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51685",
			"Name": "Manassas Park County",
			"ShortName": "Manassas Park",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51690",
			"Name": "Martinsville County",
			"ShortName": "Martinsville",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51115",
			"Name": "Mathews County",
			"ShortName": "Mathews County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51117",
			"Name": "Mecklenburg County",
			"ShortName": "Mecklenburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51119",
			"Name": "Middlesex County",
			"ShortName": "Middlesex County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51121",
			"Name": "Montgomery County",
			"ShortName": "Montgomery",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51125",
			"Name": "Nelson County",
			"ShortName": "Nelson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51127",
			"Name": "New Kent County",
			"ShortName": "New Kent County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51700",
			"Name": "Newport News City County",
			"ShortName": "Newport News City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51710",
			"Name": "Norfolk City County",
			"ShortName": "Norfolk City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51131",
			"Name": "Northampton County",
			"ShortName": "Northampton County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51133",
			"Name": "Northumberland County",
			"ShortName": "Northumberland County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51720",
			"Name": "Norton County",
			"ShortName": "Norton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51135",
			"Name": "Nottoway County",
			"ShortName": "Nottoway",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51137",
			"Name": "Orange County",
			"ShortName": "Orange",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51139",
			"Name": "Page County",
			"ShortName": "Page",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51141",
			"Name": "Patrick County",
			"ShortName": "Patrick",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51730",
			"Name": "Petersburg County",
			"ShortName": "Petersburg",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51143",
			"Name": "Pittsylvania County",
			"ShortName": "Pittsylvania",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51735",
			"Name": "Poquoson City County",
			"ShortName": "Poquoson City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51740",
			"Name": "Portsmouth City County",
			"ShortName": "Portsmouth City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51145",
			"Name": "Powhatan County",
			"ShortName": "Powhatan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51147",
			"Name": "Prince Edward County",
			"ShortName": "Prince Edward",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51149",
			"Name": "Prince George County",
			"ShortName": "Prince George County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51153",
			"Name": "Prince William County",
			"ShortName": "Prince William County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51155",
			"Name": "Pulaski County",
			"ShortName": "Pulaski",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51750",
			"Name": "Radford County",
			"ShortName": "Radford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51157",
			"Name": "Rappahannock County",
			"ShortName": "Rappahannock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51760",
			"Name": "Richmond City County",
			"ShortName": "Richmond City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51159",
			"Name": "Richmond County",
			"ShortName": "Richmond County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51161",
			"Name": "Roanoke County",
			"ShortName": "Roanoke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51770",
			"Name": "Roanoke County",
			"ShortName": "Roanoke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51163",
			"Name": "Rockbridge County",
			"ShortName": "Rockbridge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51165",
			"Name": "Rockingham County",
			"ShortName": "Rockingham",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51167",
			"Name": "Russell County",
			"ShortName": "Russell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51775",
			"Name": "Salem County",
			"ShortName": "Salem",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51169",
			"Name": "Scott County",
			"ShortName": "Scott",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51171",
			"Name": "Shenandoah County",
			"ShortName": "Shenandoah",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51173",
			"Name": "Smyth County",
			"ShortName": "Smyth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51175",
			"Name": "Southampton County",
			"ShortName": "Southampton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51177",
			"Name": "Spotsylvania County",
			"ShortName": "Spotsylvania County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51179",
			"Name": "Stafford County",
			"ShortName": "Stafford County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51790",
			"Name": "Staunton County",
			"ShortName": "Staunton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51800",
			"Name": "Suffolk City County",
			"ShortName": "Suffolk City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51181",
			"Name": "Surry County",
			"ShortName": "Surry County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51183",
			"Name": "Sussex County",
			"ShortName": "Sussex",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51185",
			"Name": "Tazewell County",
			"ShortName": "Tazewell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51810",
			"Name": "Virginia Beach City County",
			"ShortName": "Virginia Beach City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51187",
			"Name": "Warren County",
			"ShortName": "Warren",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51191",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51820",
			"Name": "Waynesboro County",
			"ShortName": "Waynesboro",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51193",
			"Name": "Westmoreland County",
			"ShortName": "Westmoreland County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51830",
			"Name": "Williamsburg City County",
			"ShortName": "Williamsburg City",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51840",
			"Name": "Winchester County",
			"ShortName": "Winchester",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51195",
			"Name": "Wise County",
			"ShortName": "Wise",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51197",
			"Name": "Wythe County",
			"ShortName": "Wythe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "51199",
			"Name": "York County",
			"ShortName": "York County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "53",
		"StateName": "Washington",
		"Counties": [{
			"GeoId": "53001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53003",
			"Name": "Asotin County",
			"ShortName": "Asotin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53005",
			"Name": "Benton County",
			"ShortName": "Benton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53007",
			"Name": "Chelan County",
			"ShortName": "Chelan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53009",
			"Name": "Clallam County",
			"ShortName": "Clallam County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53011",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53013",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53015",
			"Name": "Cowlitz County",
			"ShortName": "Cowlitz",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53017",
			"Name": "Douglas County",
			"ShortName": "Douglas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53019",
			"Name": "Ferry County",
			"ShortName": "Ferry",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53021",
			"Name": "Franklin County",
			"ShortName": "Franklin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53023",
			"Name": "Garfield County",
			"ShortName": "Garfield",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53025",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53027",
			"Name": "Grays Harbor County",
			"ShortName": "Grays Harbor County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53029",
			"Name": "Island County",
			"ShortName": "Island County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53031",
			"Name": "Jefferson County",
			"ShortName": "Jefferson County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53033",
			"Name": "King County",
			"ShortName": "King County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53035",
			"Name": "Kitsap County",
			"ShortName": "Kitsap County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53037",
			"Name": "Kittitas County",
			"ShortName": "Kittitas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53039",
			"Name": "Klickitat County",
			"ShortName": "Klickitat",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53041",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53043",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53045",
			"Name": "Mason County",
			"ShortName": "Mason County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53047",
			"Name": "Okanogan County",
			"ShortName": "Okanogan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53049",
			"Name": "Pacific County",
			"ShortName": "Pacific County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53051",
			"Name": "Pend Oreille County",
			"ShortName": "Pend Oreille",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53053",
			"Name": "Pierce County",
			"ShortName": "Pierce County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53055",
			"Name": "San Juan County",
			"ShortName": "San Juan County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53057",
			"Name": "Skagit County",
			"ShortName": "Skagit County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53059",
			"Name": "Skamania County",
			"ShortName": "Skamania",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53061",
			"Name": "Snohomish County",
			"ShortName": "Snohomish County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53063",
			"Name": "Spokane County",
			"ShortName": "Spokane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53065",
			"Name": "Stevens County",
			"ShortName": "Stevens",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53067",
			"Name": "Thurston County",
			"ShortName": "Thurston County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53069",
			"Name": "Wahkiakum County",
			"ShortName": "Wahkiakum County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53071",
			"Name": "Walla Walla County",
			"ShortName": "Walla Walla",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53073",
			"Name": "Whatcom County",
			"ShortName": "Whatcom County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53075",
			"Name": "Whitman County",
			"ShortName": "Whitman",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "53077",
			"Name": "Yakima County",
			"ShortName": "Yakima",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "54",
		"StateName": "West Virginia",
		"Counties": [{
			"GeoId": "54001",
			"Name": "Barbour County",
			"ShortName": "Barbour",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54003",
			"Name": "Berkeley County",
			"ShortName": "Berkeley",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54005",
			"Name": "Boone County",
			"ShortName": "Boone",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54007",
			"Name": "Braxton County",
			"ShortName": "Braxton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54009",
			"Name": "Brooke County",
			"ShortName": "Brooke",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54011",
			"Name": "Cabell County",
			"ShortName": "Cabell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54013",
			"Name": "Calhoun County",
			"ShortName": "Calhoun",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54015",
			"Name": "Clay County",
			"ShortName": "Clay",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54017",
			"Name": "Doddridge County",
			"ShortName": "Doddridge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54019",
			"Name": "Fayette County",
			"ShortName": "Fayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54021",
			"Name": "Gilmer County",
			"ShortName": "Gilmer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54023",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54025",
			"Name": "Greenbrier County",
			"ShortName": "Greenbrier",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54027",
			"Name": "Hampshire County",
			"ShortName": "Hampshire",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54029",
			"Name": "Hancock County",
			"ShortName": "Hancock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54031",
			"Name": "Hardy County",
			"ShortName": "Hardy",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54033",
			"Name": "Harrison County",
			"ShortName": "Harrison",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54035",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54037",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54039",
			"Name": "Kanawha County",
			"ShortName": "Kanawha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54041",
			"Name": "Lewis County",
			"ShortName": "Lewis",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54043",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54045",
			"Name": "Logan County",
			"ShortName": "Logan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54049",
			"Name": "Marion County",
			"ShortName": "Marion",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54051",
			"Name": "Marshall County",
			"ShortName": "Marshall",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54053",
			"Name": "Mason County",
			"ShortName": "Mason",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54047",
			"Name": "McDowell County",
			"ShortName": "McDowell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54055",
			"Name": "Mercer County",
			"ShortName": "Mercer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54057",
			"Name": "Mineral County",
			"ShortName": "Mineral",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54059",
			"Name": "Mingo County",
			"ShortName": "Mingo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54061",
			"Name": "Monongalia County",
			"ShortName": "Monongalia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54063",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54065",
			"Name": "Morgan County",
			"ShortName": "Morgan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54067",
			"Name": "Nicholas County",
			"ShortName": "Nicholas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54069",
			"Name": "Ohio County",
			"ShortName": "Ohio",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54071",
			"Name": "Pendleton County",
			"ShortName": "Pendleton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54073",
			"Name": "Pleasants County",
			"ShortName": "Pleasants",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54075",
			"Name": "Pocahontas County",
			"ShortName": "Pocahontas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54077",
			"Name": "Preston County",
			"ShortName": "Preston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54079",
			"Name": "Putnam County",
			"ShortName": "Putnam",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54081",
			"Name": "Raleigh County",
			"ShortName": "Raleigh",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54083",
			"Name": "Randolph County",
			"ShortName": "Randolph",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54085",
			"Name": "Ritchie County",
			"ShortName": "Ritchie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54087",
			"Name": "Roane County",
			"ShortName": "Roane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54089",
			"Name": "Summers County",
			"ShortName": "Summers",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54091",
			"Name": "Taylor County",
			"ShortName": "Taylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54093",
			"Name": "Tucker County",
			"ShortName": "Tucker",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54095",
			"Name": "Tyler County",
			"ShortName": "Tyler",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54097",
			"Name": "Upshur County",
			"ShortName": "Upshur",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54099",
			"Name": "Wayne County",
			"ShortName": "Wayne",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54101",
			"Name": "Webster County",
			"ShortName": "Webster",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54103",
			"Name": "Wetzel County",
			"ShortName": "Wetzel",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54105",
			"Name": "Wirt County",
			"ShortName": "Wirt",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54107",
			"Name": "Wood County",
			"ShortName": "Wood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "54109",
			"Name": "Wyoming County",
			"ShortName": "Wyoming",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "55",
		"StateName": "Wisconsin",
		"Counties": [{
			"GeoId": "55001",
			"Name": "Adams County",
			"ShortName": "Adams",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55003",
			"Name": "Ashland County",
			"ShortName": "Ashland County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55005",
			"Name": "Barron County",
			"ShortName": "Barron",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55007",
			"Name": "Bayfield County",
			"ShortName": "Bayfield County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55009",
			"Name": "Brown County",
			"ShortName": "Brown County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55011",
			"Name": "Buffalo County",
			"ShortName": "Buffalo",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55013",
			"Name": "Burnett County",
			"ShortName": "Burnett",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55015",
			"Name": "Calumet County",
			"ShortName": "Calumet",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55017",
			"Name": "Chippewa County",
			"ShortName": "Chippewa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55019",
			"Name": "Clark County",
			"ShortName": "Clark",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55021",
			"Name": "Columbia County",
			"ShortName": "Columbia",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55023",
			"Name": "Crawford County",
			"ShortName": "Crawford",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55025",
			"Name": "Dane County",
			"ShortName": "Dane",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55027",
			"Name": "Dodge County",
			"ShortName": "Dodge",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55029",
			"Name": "Door County",
			"ShortName": "Door County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55031",
			"Name": "Douglas County",
			"ShortName": "Douglas County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55033",
			"Name": "Dunn County",
			"ShortName": "Dunn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55035",
			"Name": "Eau Claire County",
			"ShortName": "Eau Claire",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55037",
			"Name": "Florence County",
			"ShortName": "Florence",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55039",
			"Name": "Fond du Lac County",
			"ShortName": "Fond du Lac",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55041",
			"Name": "Forest County",
			"ShortName": "Forest",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55043",
			"Name": "Grant County",
			"ShortName": "Grant",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55045",
			"Name": "Green County",
			"ShortName": "Green",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55047",
			"Name": "Green Lake County",
			"ShortName": "Green Lake",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55049",
			"Name": "Iowa County",
			"ShortName": "Iowa",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55051",
			"Name": "Iron County",
			"ShortName": "Iron County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55053",
			"Name": "Jackson County",
			"ShortName": "Jackson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55055",
			"Name": "Jefferson County",
			"ShortName": "Jefferson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55057",
			"Name": "Juneau County",
			"ShortName": "Juneau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55059",
			"Name": "Kenosha County",
			"ShortName": "Kenosha County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55061",
			"Name": "Kewaunee County",
			"ShortName": "Kewaunee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55063",
			"Name": "La Crosse County",
			"ShortName": "La Crosse",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55065",
			"Name": "Lafayette County",
			"ShortName": "Lafayette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55067",
			"Name": "Langlade County",
			"ShortName": "Langlade",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55069",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55071",
			"Name": "Manitowoc County",
			"ShortName": "Manitowoc County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55073",
			"Name": "Marathon County",
			"ShortName": "Marathon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55075",
			"Name": "Marinette County",
			"ShortName": "Marinette County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55077",
			"Name": "Marquette County",
			"ShortName": "Marquette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55078",
			"Name": "Menominee County",
			"ShortName": "Menominee",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55079",
			"Name": "Milwaukee County",
			"ShortName": "Milwaukee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55081",
			"Name": "Monroe County",
			"ShortName": "Monroe",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55083",
			"Name": "Oconto County",
			"ShortName": "Oconto County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55085",
			"Name": "Oneida County",
			"ShortName": "Oneida",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55087",
			"Name": "Outagamie County",
			"ShortName": "Outagamie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55089",
			"Name": "Ozaukee County",
			"ShortName": "Ozaukee County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55091",
			"Name": "Pepin County",
			"ShortName": "Pepin",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55093",
			"Name": "Pierce County",
			"ShortName": "Pierce",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55095",
			"Name": "Polk County",
			"ShortName": "Polk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55097",
			"Name": "Portage County",
			"ShortName": "Portage",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55099",
			"Name": "Price County",
			"ShortName": "Price",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55101",
			"Name": "Racine County",
			"ShortName": "Racine County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55103",
			"Name": "Richland County",
			"ShortName": "Richland",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55105",
			"Name": "Rock County",
			"ShortName": "Rock",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55107",
			"Name": "Rusk County",
			"ShortName": "Rusk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55111",
			"Name": "Sauk County",
			"ShortName": "Sauk",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55113",
			"Name": "Sawyer County",
			"ShortName": "Sawyer",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55115",
			"Name": "Shawano County",
			"ShortName": "Shawano",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55117",
			"Name": "Sheboygan County",
			"ShortName": "Sheboygan County",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55109",
			"Name": "St. Croix County",
			"ShortName": "St. Croix",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55119",
			"Name": "Taylor County",
			"ShortName": "Taylor",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55121",
			"Name": "Trempealeau County",
			"ShortName": "Trempealeau",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55123",
			"Name": "Vernon County",
			"ShortName": "Vernon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55125",
			"Name": "Vilas County",
			"ShortName": "Vilas",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55127",
			"Name": "Walworth County",
			"ShortName": "Walworth",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55129",
			"Name": "Washburn County",
			"ShortName": "Washburn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55131",
			"Name": "Washington County",
			"ShortName": "Washington",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55133",
			"Name": "Waukesha County",
			"ShortName": "Waukesha",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55135",
			"Name": "Waupaca County",
			"ShortName": "Waupaca",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55137",
			"Name": "Waushara County",
			"ShortName": "Waushara",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55139",
			"Name": "Winnebago County",
			"ShortName": "Winnebago",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "55141",
			"Name": "Wood County",
			"ShortName": "Wood",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}],
		"Watersheds": [null]
	}, {
		"StateFIPS": "56",
		"StateName": "Wyoming",
		"Counties": [{
			"GeoId": "56001",
			"Name": "Albany County",
			"ShortName": "Albany",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56003",
			"Name": "Big Horn County",
			"ShortName": "Big Horn",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56005",
			"Name": "Campbell County",
			"ShortName": "Campbell",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56007",
			"Name": "Carbon County",
			"ShortName": "Carbon",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56009",
			"Name": "Converse County",
			"ShortName": "Converse",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56011",
			"Name": "Crook County",
			"ShortName": "Crook",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56013",
			"Name": "Fremont County",
			"ShortName": "Fremont",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56015",
			"Name": "Goshen County",
			"ShortName": "Goshen",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56017",
			"Name": "Hot Springs County",
			"ShortName": "Hot Springs",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56019",
			"Name": "Johnson County",
			"ShortName": "Johnson",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56021",
			"Name": "Laramie County",
			"ShortName": "Laramie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56023",
			"Name": "Lincoln County",
			"ShortName": "Lincoln",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56025",
			"Name": "Natrona County",
			"ShortName": "Natrona",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56027",
			"Name": "Niobrara County",
			"ShortName": "Niobrara",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56029",
			"Name": "Park County",
			"ShortName": "Park",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56031",
			"Name": "Platte County",
			"ShortName": "Platte",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56033",
			"Name": "Sheridan County",
			"ShortName": "Sheridan",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56035",
			"Name": "Sublette County",
			"ShortName": "Sublette",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56037",
			"Name": "Sweetwater County",
			"ShortName": "Sweetwater",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56039",
			"Name": "Teton County",
			"ShortName": "Teton",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56041",
			"Name": "Uinta County",
			"ShortName": "Uinta",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56043",
			"Name": "Washakie County",
			"ShortName": "Washakie",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}, {
			"GeoId": "56045",
			"Name": "Weston County",
			"ShortName": "Weston",
			"maxZoom": "15",
			"hiRes": false,
			"Years": availableYears,
			"Suffix": "County"
		}]
  }], "Watersheds": [null]}